import useChatGuidanceVisibility from '../../components/common/chat/shared/useChatGuidanceVisibility';
import useChatTopics, { useTopicReplyNavigation, isTopicRequestSuperseded, selectTopicForReply, bindTopicUploadApi, bindTopicMessageApi, useTopicMessageState, useTopicModeReload } from '../../components/common/chat/topics/useChatTopics';
import { ChatTopicsProvider } from '../../components/common/chat/topics/ChatTopicsContext';
/* eslint-disable react-hooks/exhaustive-deps */
// frontend/src/components/artist/chats/ArtistChatPage.js
import React, { useState, useEffect, useLayoutEffect, useRef, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import '../../css/artist/chats/ArtistChatPage.css';
import { useArtistAuth } from '../../contexts/ArtistAuthContext';
import {
  ADMIN_MESSAGE_FORMATS,
  isHoldAnnouncementFormat,
  isInvoiceResubmissionRequestedFormat,
  isPartAnnouncementFormat,
  isStageSeatingShareAnnouncementFormat,
} from '../../constants/messageFormats';
import { useMessageCount } from '../../contexts/MessageCountContext';
import { useChatUnreadDivider } from '../../components/common/chat/timeline/chatUnreadDivider';
import useChatProfileModalState from '../../components/common/chat/members/useChatProfileModalState';
import ChatMessageSelectableCopyArea from '../../components/common/chat/timeline/ChatMessageSelectableCopyArea';
import useChatAnnouncements from '../../components/common/chat/announcements/useChatAnnouncements';
import useDelayedVisibility from '../../components/common/chat/shared/useDelayedVisibility';
import useChatMessageReactions from '../../components/common/chat/reactions/useChatMessageReactions';
import useChatNotesBadgeCount from '../../components/common/chat/notes/useChatNotesBadgeCount';
import useViewportBoundedMenuPosition from '../../components/common/chat/shared/useViewportBoundedMenuPosition';
import { focusChatAnchorMessage } from '../../components/common/chat/timeline/chatMessageAnchorUtils';
import { supportsChatMessageReaction } from '../../components/common/chat/reactions/chatMessageReactionUtils';
import {
  hasCopyableChatMessageText,
  resolveCopyableChatMessageText,
  writeTextToClipboard,
} from '../../components/common/chat/timeline/chatMessageCopyUtils';
import { useToast } from '../../components/common/ToastSystem';
import { useMaintenance, MAINTENANCE_MODES } from '../../contexts/MaintenanceContext';
import useChatMentionTaskResolution from '../../components/common/chat/mentions/useChatMentionTaskResolution';
import { buildToolbarFilterChips } from '../../components/common/chat/search/chatTargetSearchChipUtils';
import EventChatAvatarNode from '../../components/common/chat/avatars/EventChatAvatarNode';
import { openExternalUrl } from '../../utils/externalLink';
import { buildAdminProfileForModal } from '../../components/common/chat/members/memberModalProfileUtils';
import { getSocket } from '../../lib/socket';
import { SOCKET_EVENTS } from '../../lib/socketEvents';
import {
  getSystemToneClass,
  parseReminderTags,
  sanitizeReminderContent,
} from '../../components/common/chat/timeline/systemMessageUtils';
import { appendVariant } from '../../components/common/chat/composer/chatAssetUtils';
import { buildImageGroupDisplayMessages } from '../../components/common/chat/composer/chatImageGroupUtils';
import { appendBubbleFormatClassName } from '../../components/common/chat/timeline/messageBubbleClassUtils';
import {
  extractAdminParticipantsFromMessages,
  mapArtistContractSummaryEntry,
  mapArtistOfferSummaryEntry,
  sortAndTrimSummaryEntries,
} from '../../components/common/chat/sidepanel/individualSidePanelSummaryUtils';
// ★ 共通D&D（フック＋オーバーレイ）
import useChatDragDrop from '../../components/common/chat/composer/useChatDragDrop';
import { buildChatDropPlan } from '../../components/common/chat/composer/chatDropPlan';
import '../../css/common/chat/ChatDragDrop.css';
// ★ 日時ユーティリティ（Adminと統一）
import { isWithinHoursFromNow, toYmdSlash, toHHmm } from '../../utils/datetime';
import { normalizeGenresPayload } from '../../utils/genreUtils';
import { clearActiveChatContext, setActiveChatContext } from '../../utils/activeChatContext';
import {
  buildChatMentionCandidates,
  normalizeMentionLabel,
  normalizeMentionTargetId,
  normalizeMentionTargetRole,
  normalizeMentionTargetType,
} from '../../components/common/chat/mentions/chatMentionUtils';
import {
  deleteArtistMessage,
  listArtistGroupChatThreads,
  listArtistContracts,
  listArtistHoldCastings,
  listArtistMentionCandidates,
  listArtistMessages as rawListArtistMessages,
  listArtistMessagesAround as rawListArtistMessagesAround,
  listArtistMessagesBefore as rawListArtistMessagesBefore,
  listArtistNewMessages as rawListArtistNewMessages,
  listArtistPendingMentionTargets,
  resolveArtistMentionTarget,
  searchArtistMessages,
  sendArtistFileMessage as rawSendArtistFileMessage,
  sendArtistImageMessages as rawSendArtistImageMessages,
} from '../../api/artistChat';
import { getEventDetail } from '../../api/taskEvents';
import { listGenres } from '../../api/genres';
import { getReminderSchedule } from '../../api/reminders';
import { mergeMessages, patchMessages, removeMessages } from '../../components/common/chat/timeline/timelineMerge';
import { makeLinkPreviewReadyHandler } from '../../components/common/chat/timeline/linkPreviewRealtime';
import { buildArtistChatReplyDraft, canMarkArtistChatRead, API_URL, ADMIN_PROFILE_IMAGE_PATH, TACTICART_TARGET_ICON_PATH, TACTICART_PERSONAL_CHAT_TARGET_INTRO, buildAssetUrl, buildFlyerUrl, buildMessageImageUrl, buildGroupChatIconUrl, buildArtistPersonalNotesListUrl, firstNonEmpty, normalizeRealtimePayload, pickRealtimeThreadId, buildSidebarPreviewText, buildGroupThreadPreviewText, buildRealtimeGroupThreadMessage, buildRealtimePersonalTextMessage, normalizeId, isSameId, PERSONAL_ADMIN_PARTICIPANT_LIMIT, buildPersonalAdminParticipants, UNSENDABLE_FORMATS, ARTIST_TARGET_ROW_CLASSES, getIsMobileViewport, readQuestionMessageTarget } from './useArtistChatPageElement.helpers';
import ArtistChatPageView from './useArtistChatPageElement.view';
import { shouldIgnorePopStateForHistoryDismiss } from '../common/useHistoryDismiss';
export default function useArtistChatPageElement() {
  const ACTIVE_CHAT_OWNER = 'artist:mixed-chat';
  const location = useLocation();
  const { artistUser } = useArtistAuth();
  const { error: toastError, success: toastSuccess } = useToast();
  const { maintenance, maintenanceMode } = useMaintenance();
  const isReadOnly =
    maintenanceMode === MAINTENANCE_MODES.READ_ONLY || (maintenance && maintenance.readOnly);
  // mount/visibility guards
  const isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    return () => { isMountedRef.current = false; };
  }, []);
  const [isPageVisible, setIsPageVisible] = useState(document.visibilityState === 'visible');
  const isPageVisibleRef = useRef(isPageVisible);
  useEffect(() => {
    const h = () => setIsPageVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', h);
    return () => document.removeEventListener('visibilitychange', h);
  }, []);
  useEffect(() => {
    isPageVisibleRef.current = isPageVisible;
  }, [isPageVisible]);

  const chatTopics = useChatTopics({ scope: 'individual', conversationId: artistUser?.userId, role: 'artist', accountId: artistUser?.userId });
  const listArtistMessages = useCallback(bindTopicMessageApi(chatTopics, rawListArtistMessages, 2, null), [chatTopics]);
  const listArtistMessagesAround = useCallback(bindTopicMessageApi(chatTopics, rawListArtistMessagesAround, 3, null), [chatTopics]);
  const listArtistMessagesBefore = useCallback(bindTopicMessageApi(chatTopics, rawListArtistMessagesBefore, 2, null), [chatTopics]);
  const listArtistNewMessages = useCallback(bindTopicMessageApi(chatTopics, rawListArtistNewMessages, 1, null), [chatTopics]);
  const [messages, setMessages] = useTopicMessageState(chatTopics);
  const sendArtistImageMessages = useCallback(bindTopicUploadApi(chatTopics, rawSendArtistImageMessages), [chatTopics]);
  const sendArtistFileMessage = useCallback(bindTopicUploadApi(chatTopics, rawSendArtistFileMessage), [chatTopics]);
  const [replyDraft, setReplyDraft] = useState(null);
  const [showNotes, setShowNotes] = useState(false);
  const messagesRef = useRef([]);
  const artistUserRef = useRef(null);
  const [genres, setGenres] = useState([]);
  const [offerAnnouncements, setOfferAnnouncements] = useState([]);
  const [contractAnnouncements, setContractAnnouncements] = useState([]);
  const chatContainerRef = useRef(null);
  const chatWrapRef = useRef(null);          // ★ D&D監視は“コンテナ”で
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [messageMenu, setMessageMenu] = useState(null);
  const [inlineCopyMessageId, setInlineCopyMessageId] = useState('');
  const imageModalHistoryRef = useRef({ pushed: false, closing: false });
  const fetchInitialMessagesRef = useRef(null);
  const {
    profileTarget,
    closeProfileModal,
    openAdminProfile: openAdminProfileState,
  } = useChatProfileModalState();
  const longPressTimerRef = useRef(null);
  const anchorHighlightTimerRef = useRef(null);

  const [hasMore, setHasMore] = useState(true);
  const [hasNewerMessages, setHasNewerMessages] = useState(false);
  const [loadingNewerMessages, setLoadingNewerMessages] = useState(false);
  const [loadingOlderMessages, setLoadingOlderMessages] = useState(false);
  const [messageWindowOffset, setMessageWindowOffset] = useState(0);
  const [activeAnchorMessageId, setActiveAnchorMessageId] = useState('');
  const limit = 20;
  const [isFetching, setIsFetching] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(false);
  const isFetchingRef = useRef(isFetching);
  const reminderCacheRef = useRef(new Map());
  const [, setReminderCacheVersion] = useState(0);
  const {
    artistPersonalMessageCount,
    artistGroupUnreadMap,
    markArtistGroupThreadAsRead,
    setArtistMessageCount,
  } = useMessageCount();

  // 「ここから未読」の境界。出演者の個人チャットは1本なので合計未読がそのまま件数になる。
  const unreadDividerMessageId = useChatUnreadDivider({
    conversationKey: 'direct:artist:self',
    unreadCount: Number(artistPersonalMessageCount || 0),
    messages,
  });

  const [showNewMsgBanner, setShowNewMsgBanner] = useState(false);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(true);
  const flyerCacheRef = useRef(new Map());
  const [, setFlyerCacheVersion] = useState(0);
  const eventDetailCacheRef = useRef(new Map());
  const eventDetailInflightRef = useRef(new Map());
  const bannerTimeoutRef = useRef(null);

  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  useEffect(() => {
    artistUserRef.current = artistUser;
  }, [artistUser]);
  useEffect(
    () => () => {
      if (anchorHighlightTimerRef.current) {
        clearTimeout(anchorHighlightTimerRef.current);
        anchorHighlightTimerRef.current = null;
      }
    },
    [],
  );

  const [oldestCursor, setOldestCursor] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const lastDiffFetchRef = useRef(Date.now());
  const STALE_MS = 60 * 60 * 1000; // 60分超ならフルリロード
  const initialQuestionTarget = useMemo(() => readQuestionMessageTarget(location.search), [location.search]);
  const [groupThreads, setGroupThreads] = useState([]);
  const groupThreadsRef = useRef([]);
  const [personalSearchHits, setPersonalSearchHits] = useState([]);
  const [isLoadingGroupThreads, setIsLoadingGroupThreads] = useState(false);
  const [groupThreadsLoaded, setGroupThreadsLoaded] = useState(false);
  const [selectedGroupTopic, setSelectedGroupTopic] = useState(undefined);
  const [selectedGroupThreadId, setSelectedGroupThreadId] = useState(initialQuestionTarget.threadId);
  const [selectedGroupAnchorMessageId, setSelectedGroupAnchorMessageId] = useState(initialQuestionTarget.groupAnchorMessageId);
  const [, setSelectedPersonalAnchorMessageId] = useState(initialQuestionTarget.personalAnchorMessageId);
  const [activeChatTarget, setActiveChatTarget] = useState(initialQuestionTarget.activeChatTarget); // '' | 'personal' | 'group'
  const quickTaskInitialMentionDraft = useMemo(() => {
    const params = new URLSearchParams(location.search || '');
    const stateDraft = location.state?.quickTaskInitialMention || {};
    const adminId = normalizeId(
      stateDraft.adminId ||
        stateDraft.targetId ||
        params.get('quickTaskMentionAdminId') ||
        params.get('quick_task_mention_admin_id')
    );
    const label = String(
      stateDraft.label ||
        params.get('quickTaskMentionLabel') ||
        params.get('quick_task_mention_label') ||
        ''
    ).replace(/^@+/, '').trim();
    if (!adminId || !label) return null;
    const taskId = normalizeId(
      stateDraft.taskId ||
        params.get('quickTaskId') ||
        params.get('quick_task_id')
    );
    const text = `@${label} `;
    return {
      key: `quick-task:${taskId || adminId}:${adminId}`,
      text,
      mentions: [
        {
          type: 'person',
          role: 'admin',
          id: adminId,
          label,
          start: 0,
          end: text.trimEnd().length,
        },
      ],
    };
  }, [location.search, location.state]);
  const activeChatTargetRef = useRef(activeChatTarget);
  const selectedGroupThreadIdRef = useRef(selectedGroupThreadId);
  const [pendingMentionTargets, setPendingMentionTargets] = useState({});
  const [pendingGroupMentionTargets, setPendingGroupMentionTargets] = useState({});
  const [resolvingMentionTargetId, setResolvingMentionTargetId] = useState('');
  const [recentMentionAdmins, setRecentMentionAdmins] = useState([]);
  const [searchedMentionAdmins, setSearchedMentionAdmins] = useState([]);
  const mentionCandidateSearchTimerRef = useRef(null);
  const [roomTypeFilter, setRoomTypeFilter] = useState('');
  const [roomNameFilter, setRoomNameFilter] = useState('');
  const [messageFilter, setMessageFilter] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchDraft, setSearchDraft] = useState({ roomType: '', roomName: '', message: '' });
  useEffect(() => {
    const params = new URLSearchParams(location.search || '');
    const requestedRoomType = String(params.get('roomType') || params.get('room_type') || '').trim();
    if (requestedRoomType !== 'personal' && requestedRoomType !== 'group') return;
    setRoomTypeFilter((current) => (current === requestedRoomType ? current : requestedRoomType));
    setSearchDraft((current) => (
      current.roomType === requestedRoomType ? current : { ...current, roomType: requestedRoomType }
    ));
  }, [location.search]);
  const isGroupTarget = activeChatTarget === 'group' && !!selectedGroupThreadId;
  const showTargetSidebar = true;
  const isPersonalTargetActive = activeChatTarget === 'personal';
  chatTopics.enabled = isPersonalTargetActive && Boolean(artistUser?.userId);
  const ownArtistId = normalizeId(
    artistUser?.userId || artistUser?.artistId || artistUser?.artist_id || artistUser?.id,
  );
  const personalAdminParticipants = useMemo(
    () => buildPersonalAdminParticipants({
      recentAdmins: recentMentionAdmins,
      messageAdmins: extractAdminParticipantsFromMessages(messages),
      searchedAdmins: searchedMentionAdmins,
    }),
    [messages, recentMentionAdmins, searchedMentionAdmins],
  );
  const personalMentionCandidates = useMemo(() => {
    return buildChatMentionCandidates({
      admins: personalAdminParticipants,
      includeArtists: false,
      includeParts: false,
    });
  }, [personalAdminParticipants]);
  const personalMentionCandidateLookup = useMemo(() => {
    const lookup = new Map();
    personalMentionCandidates.forEach((candidate) => {
      if (candidate?.type === 'person' && candidate?.role && candidate?.id) {
        lookup.set(`${candidate.role}:${candidate.id}`, candidate);
      }
    });
    return lookup;
  }, [personalMentionCandidates]);

  const refreshPendingMentionTargets = useCallback(async () => {
    try {
      const data = await listArtistPendingMentionTargets({ scope: 'personal' });
      const next = {};
      (Array.isArray(data?.targets) ? data.targets : []).forEach((target) => {
        const id = normalizeId(target?.targetId);
        if (!id) return;
        next[id] = {
          count: Number(target?.count || 0),
          messageId: target?.messageId || target?.message_id || null,
          latestCreatedAt: target?.latestCreatedAt || null,
        };
      });
      setPendingMentionTargets(next);
    } catch {
      setPendingMentionTargets({});
    }
  }, []);

  const refreshPendingGroupMentionTargets = useCallback(async () => {
    try {
      const data = await listArtistPendingMentionTargets({ scope: 'group' });
      const next = {};
      (Array.isArray(data?.targets) ? data.targets : []).forEach((target) => {
        const id = normalizeId(target?.targetId);
        if (!id) return;
        next[id] = {
          count: Number(target?.count || 0),
          messageId: target?.messageId || target?.message_id || null,
          latestCreatedAt: target?.latestCreatedAt || null,
        };
      });
      setPendingGroupMentionTargets(next);
    } catch {
      setPendingGroupMentionTargets({});
    }
  }, []);

  const resolveMentionTarget = useCallback(async (targetId) => {
    const normalizedTargetId = normalizeId(targetId);
    if (!normalizedTargetId) return;
    setResolvingMentionTargetId(normalizedTargetId);
    try {
      await resolveArtistMentionTarget({ scope: 'personal', targetId: normalizedTargetId });
      setPendingMentionTargets((current) => {
        const next = { ...current };
        delete next[normalizedTargetId];
        return next;
      });
    } catch {
      toastError('メンション対応状態の更新に失敗しました。');
    } finally {
      setResolvingMentionTargetId('');
    }
  }, [toastError]);

  const resolveGroupMentionTarget = useCallback(async (targetId) => {
    const normalizedTargetId = normalizeId(targetId);
    if (!normalizedTargetId) return;
    setResolvingMentionTargetId(normalizedTargetId);
    try {
      await resolveArtistMentionTarget({ scope: 'group', targetId: normalizedTargetId });
      setPendingGroupMentionTargets((current) => {
        const next = { ...current };
        delete next[normalizedTargetId];
        return next;
      });
    } catch {
      toastError('メンション対応状態の更新に失敗しました。');
    } finally {
      setResolvingMentionTargetId('');
    }
  }, [toastError]);

  const updatePendingMentionTargetCount = useCallback((scope, targetId, delta) => {
    const normalizedTargetId = normalizeId(targetId);
    if (!normalizedTargetId) return;
    const updateMap = (setter) => {
      setter((current) => {
        const currentTarget = current[normalizedTargetId];
        const nextCount = Math.max(0, Number(currentTarget?.count || 0) + Number(delta || 0));
        const next = { ...current };
        if (nextCount <= 0) {
          delete next[normalizedTargetId];
        } else {
          next[normalizedTargetId] = { ...currentTarget, count: nextCount };
        }
        return next;
      });
    };
    if (scope === 'personal') {
      updateMap(setPendingMentionTargets);
    } else if (scope === 'group') {
      updateMap(setPendingGroupMentionTargets);
    }
  }, []);

  const {
    modalProps: mentionResolutionModalProps,
    loadingTargetKey: loadingMentionResolutionTargetKey,
    openMentionResolution,
  } = useChatMentionTaskResolution({
    actorType: 'artist',
    onTargetCountChange: updatePendingMentionTargetCount,
    onError: toastError,
  });

  const handlePersonalMentionQueryChange = useCallback((query, state) => {
    if (mentionCandidateSearchTimerRef.current) {
      clearTimeout(mentionCandidateSearchTimerRef.current);
      mentionCandidateSearchTimerRef.current = null;
    }
    if (!state) {
      setSearchedMentionAdmins([]);
      return;
    }
    const q = String(query || '').trim();
    if (!q) {
      setSearchedMentionAdmins([]);
      return;
    }
    mentionCandidateSearchTimerRef.current = setTimeout(async () => {
      try {
        const data = await listArtistMentionCandidates({ q, limit: 20 });
        setSearchedMentionAdmins(Array.isArray(data?.admins) ? data.admins : []);
      } catch {
        setSearchedMentionAdmins([]);
      }
    }, 250);
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await listArtistMentionCandidates({
          limit: PERSONAL_ADMIN_PARTICIPANT_LIMIT,
        });
        if (!cancelled) setRecentMentionAdmins(Array.isArray(data?.admins) ? data.admins : []);
      } catch {
        if (!cancelled) setRecentMentionAdmins([]);
      }
    })();
    refreshPendingMentionTargets();
    refreshPendingGroupMentionTargets();
    return () => {
      cancelled = true;
      if (mentionCandidateSearchTimerRef.current) {
        clearTimeout(mentionCandidateSearchTimerRef.current);
        mentionCandidateSearchTimerRef.current = null;
      }
    };
  }, [refreshPendingGroupMentionTargets, refreshPendingMentionTargets]);
  const { noteCount, refreshNoteCount } = useChatNotesBadgeCount({
    ownerId: artistUser?.userId || '',
    buildListUrl: buildArtistPersonalNotesListUrl,
    enabled: Boolean(isPersonalTargetActive && !isGroupTarget && artistUser?.userId),
  });

  useEffect(() => {
    setInlineCopyMessageId('');
  }, [activeChatTarget, selectedGroupThreadId]);

  useEffect(() => {
    if ((!isPersonalTargetActive || isGroupTarget) && showNotes) {
      setShowNotes(false);
    }
  }, [isGroupTarget, isPersonalTargetActive, showNotes]);

  useEffect(() => {
    activeChatTargetRef.current = activeChatTarget;
  }, [activeChatTarget]);

  useEffect(() => {
    if (!quickTaskInitialMentionDraft) return;
    setActiveChatTarget('personal');
    setSelectedGroupThreadId('');
    setSelectedGroupAnchorMessageId('');
    setSelectedPersonalAnchorMessageId('');
  }, [quickTaskInitialMentionDraft]);

  useEffect(() => {
    selectedGroupThreadIdRef.current = selectedGroupThreadId;
  }, [selectedGroupThreadId]);

  const {
    announcements,
    latestAnnouncement,
    announcementCount,
    listOpen: isAnnouncementListOpen,
    setListOpen: setIsAnnouncementListOpen,
    refreshAnnouncements,
    pinAnnouncement,
    unpinAnnouncement,
    isAnnouncedMessage,
    actionMessageId: announcementActionMessageId,
  } = useChatAnnouncements({
    mode: 'artist',
    scope: 'individual',
    enabled: isPersonalTargetActive && !isGroupTarget,
    onError: toastError,
  });
  const {
    detailOpen: isReactionDetailOpen,
    detailGroups: reactionDetailGroups,
    detailLoading: reactionDetailLoading,
    openReactionDetail,
    closeReactionDetail,
    toggleReaction,
    refreshMessageReactionDetails,
    isReactionPending,
  } = useChatMessageReactions({
    mode: 'artist',
    scope: 'individual',
    enabled: isPersonalTargetActive && !isGroupTarget,
    setMessages,
    onError: toastError,
  });
  const normalizedMessageFilter = String(messageFilter || '').trim();
  const isMessageSearchActive = normalizedMessageFilter.length > 0;
  const sortedGroupThreads = useMemo(() => {
    const toTs = (value) => {
      const ms = new Date(value || '').getTime();
      return Number.isFinite(ms) ? ms : 0;
    };
    return [...groupThreads].sort((a, b) => {
      const aTs = toTs(a?.latest_message_at || a?.updated_at);
      const bTs = toTs(b?.latest_message_at || b?.updated_at);
      if (aTs !== bTs) return bTs - aTs;
      return String(a?.title || '').localeCompare(String(b?.title || ''), 'ja');
    });
  }, [groupThreads]);
  const personalPreviewText = useMemo(() => buildSidebarPreviewText(chatTopics.parentLastMessage), [chatTopics, messages]);
  const filteredGroupThreads = useMemo(() => {
    const normalizedRoomName = String(roomNameFilter || '').trim().toLowerCase();
    const normalizedMessage = normalizedMessageFilter.toLowerCase();
    return sortedGroupThreads.filter((thread) => {
      if (roomTypeFilter && roomTypeFilter !== 'group') return false;
      const title = String(thread?.title || '').toLowerCase();
      const preview = String(buildGroupThreadPreviewText(thread) || '').toLowerCase();
      const roomNameMatched = !normalizedRoomName || title.includes(normalizedRoomName);
      const messageMatched = isMessageSearchActive ? true : !normalizedMessage || preview.includes(normalizedMessage);
      return roomNameMatched && messageMatched;
    });
  }, [isMessageSearchActive, normalizedMessageFilter, roomNameFilter, roomTypeFilter, sortedGroupThreads]);
  const personalTargetRows = useMemo(() => {
    if (roomTypeFilter && roomTypeFilter !== 'personal') return [];
    const normalizedRoomName = String(roomNameFilter || '').trim().toLowerCase();
    const roomNameMatched = !normalizedRoomName || 'タクティカート'.includes(normalizedRoomName);
    if (!roomNameMatched) return [];
    if (isMessageSearchActive) {
      return personalSearchHits.map((hit, index) => {
        const text = String(
          hit?.excerpt ||
            hit?.content ||
            hit?.file_original_name ||
            hit?.file_name ||
            'メッセージを送信しました'
        ).trim();
        return {
          key: `personal-hit-${hit?.message_id || `${hit?.message_created_at || 'row'}-${index}`}`,
          preview: text || 'メッセージを送信しました',
          createdAt: hit?.message_created_at || null,
          searchHitMessageId: hit?.message_id || null,
        };
      });
    }
    return [
      {
        key: 'personal-default',
        preview: personalPreviewText,
        createdAt: chatTopics.parentLastMessage?.created_at || null,
        searchHitMessageId: null,
        showIntro:
          !isFetching &&
          !isInitialLoading &&
          !chatTopics.parentLastMessage,
      },
    ];
  }, [
    isFetching,
    isInitialLoading,
    isMessageSearchActive,
    messages,
    personalPreviewText,
    personalSearchHits,
    roomNameFilter,
    roomTypeFilter,
  ]);
  const showPersonalTargetRow = personalTargetRows.length > 0;
  const activeSearchFilterCount = useMemo(
    () => [String(roomTypeFilter || '').trim(), String(roomNameFilter || '').trim(), String(messageFilter || '').trim()].filter(Boolean).length,
    [messageFilter, roomNameFilter, roomTypeFilter]
  );
  const searchSummaryLabel =
    activeSearchFilterCount > 0
      ? `絞り込み中: ${activeSearchFilterCount}件`
      : '';
  const clearToolbarSearch = useCallback(() => {
    setRoomTypeFilter('');
    setRoomNameFilter('');
    setMessageFilter('');
  }, []);
  const searchToolbarChips = useMemo(
    () =>
      buildToolbarFilterChips(
        [
          {
            key: 'roomType',
            label: '種別',
            value:
              roomTypeFilter === 'personal'
                ? 'タクティカート'
                : roomTypeFilter === 'group'
                  ? 'グループチャット'
                  : '',
            onRemove: () => setRoomTypeFilter(''),
          },
          {
            key: 'roomName',
            label: 'ルーム名',
            value: roomNameFilter,
            onRemove: () => setRoomNameFilter(''),
          },
          {
            key: 'message',
            label: '本文',
            value: messageFilter,
            onRemove: () => setMessageFilter(''),
          },
        ],
        { onClearAll: clearToolbarSearch }
      ),
    [clearToolbarSearch, messageFilter, roomNameFilter, roomTypeFilter]
  );
  const isTargetSearchMode = activeSearchFilterCount > 0;
  const showDelayedInitialLoading = useDelayedVisibility(isInitialLoading, 1000);
  const openTargetSearchModal = useCallback(() => {
    setSearchDraft({
      roomType: String(roomTypeFilter || ''),
      roomName: String(roomNameFilter || ''),
      message: String(messageFilter || ''),
    });
    setShowSearchModal(true);
  }, [messageFilter, roomNameFilter, roomTypeFilter]);
  const applyTargetSearchModal = useCallback(() => {
    setRoomTypeFilter(String(searchDraft.roomType || '').trim());
    setRoomNameFilter(String(searchDraft.roomName || '').trim());
    setMessageFilter(String(searchDraft.message || '').trim());
    setShowSearchModal(false);
  }, [searchDraft.message, searchDraft.roomName, searchDraft.roomType]);
  const clearTargetSearchModal = useCallback(() => {
    setSearchDraft({ roomType: '', roomName: '', message: '' });
    setRoomTypeFilter('');
    setRoomNameFilter('');
    setMessageFilter('');
    setShowSearchModal(false);
  }, []);
  const isTargetSelectionPending = !isPersonalTargetActive && !isGroupTarget;
  const isPersonalTargetActiveRef = useRef(isPersonalTargetActive);
  const [isMobile, setIsMobile] = useState(getIsMobileViewport);
  const initialMobileView = useMemo(() => {
    if (typeof window === 'undefined') return 'split';
    return getIsMobileViewport() ? 'list' : 'split';
  }, []);
  const [mobileView, setMobileView] = useState(initialMobileView); // 'list' | 'chat' | 'split'
  const mobileTargetListPrefRef = useRef(false);
  const mobileTargetChatHistoryRef = useRef(false);
  const resolvedMobileView = isMobile ? mobileView : 'split';
  const showMobileTargetBackButton = isMobile && resolvedMobileView === 'chat';

  useEffect(() => {
    if (isGroupTarget && selectedGroupThreadId) {
      setActiveChatContext({
        topicId: chatTopics.topicId || chatTopics.draftTopic?.clientId || '',
        owner: ACTIVE_CHAT_OWNER,
        scope: 'artist',
        channel: 'group',
        threadId: selectedGroupThreadId,
      });
      return () => clearActiveChatContext(ACTIVE_CHAT_OWNER);
    }
    if (isPersonalTargetActive) {
      setActiveChatContext({
        topicId: chatTopics.topicId || chatTopics.draftTopic?.clientId || '',
        owner: ACTIVE_CHAT_OWNER,
        scope: 'artist',
        channel: 'personal',
      });
      return () => clearActiveChatContext(ACTIVE_CHAT_OWNER);
    }
    clearActiveChatContext(ACTIVE_CHAT_OWNER);
    return () => clearActiveChatContext(ACTIVE_CHAT_OWNER);
  }, [isGroupTarget, isPersonalTargetActive, selectedGroupThreadId]);

  useEffect(() => {
    const syncViewport = () => setIsMobile(getIsMobileViewport());
    syncViewport();
    window.addEventListener('resize', syncViewport);
    return () => window.removeEventListener('resize', syncViewport);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      mobileTargetListPrefRef.current = false;
      artistGroupDbg('mobile-view:force-split-desktop');
      setMobileView('split');
      return;
    }
    if (mobileTargetListPrefRef.current) {
      artistGroupDbg('mobile-view:prefer-list-history');
      setMobileView('list');
      return;
    }
    if (isPersonalTargetActive || isGroupTarget) {
      artistGroupDbg('mobile-view:force-chat-has-target', {
        isPersonalTargetActive,
        isGroupTarget,
      });
      setMobileView('chat');
    } else {
      artistGroupDbg('mobile-view:default-list-no-target');
      setMobileView('list');
    }
  }, [isGroupTarget, isMobile, isPersonalTargetActive]);

  useEffect(() => {
    if (!isMobile) {
      mobileTargetChatHistoryRef.current = false;
      return;
    }

    const hasSelectedTarget = isPersonalTargetActive || isGroupTarget;
    if (
      resolvedMobileView === 'chat' &&
      hasSelectedTarget &&
      !mobileTargetListPrefRef.current &&
      !mobileTargetChatHistoryRef.current
    ) {
      try {
        const target = isGroupTarget ? normalizeId(selectedGroupThreadId) || 'group' : 'personal';
        window.history.pushState({ acp: 'chat', target }, '');
        mobileTargetChatHistoryRef.current = true;
      } catch {
        mobileTargetChatHistoryRef.current = false;
      }
      return;
    }

    if (resolvedMobileView !== 'chat') {
      mobileTargetChatHistoryRef.current = false;
    }
  }, [
    isGroupTarget,
    isMobile,
    isPersonalTargetActive,
    resolvedMobileView,
    selectedGroupThreadId,
  ]);

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    const listOnly = isMobile && resolvedMobileView === 'list';
    const chatMode = isGroupTarget ? 'group' : 'artist';
    window.dispatchEvent(
      new CustomEvent('casticart:chat-footer', { detail: { listOnly, chatMode } })
    );
  }, [isGroupTarget, isMobile, resolvedMobileView]);

  useEffect(() => {
    const onPop = (event) => {
      if (shouldIgnorePopStateForHistoryDismiss(event)) return;
      artistGroupDbg('history:popstate', {
        isModalOpen,
        isMobile,
        showTargetSidebar,
        resolvedMobileView,
      });
      if (imageModalHistoryRef.current.closing) {
        imageModalHistoryRef.current.closing = false;
        imageModalHistoryRef.current.pushed = false;
        return;
      }
      if (isModalOpen) {
        imageModalHistoryRef.current.pushed = false;
        setIsModalOpen(false);
        return;
      }
      if (isMobile && resolvedMobileView === 'chat') {
        mobileTargetListPrefRef.current = true;
        mobileTargetChatHistoryRef.current = false;
        setMobileView('list');
      }
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [isMobile, isModalOpen, resolvedMobileView]);

  useEffect(() => {
    isPersonalTargetActiveRef.current = isPersonalTargetActive;
  }, [isPersonalTargetActive]);

  useEffect(() => {
    if (isPersonalTargetActive) return;
    setUnreadCount(Number(artistPersonalMessageCount || 0));
  }, [artistPersonalMessageCount, isPersonalTargetActive]);

  const artistGroupDbg =
    process.env.NODE_ENV !== 'production'
      ? (...args) => console.log('[ArtistChatDBG][group]', ...args)
      : () => {};

  const loadGroupThreads = useCallback(
    async (silent = false) => {
      artistGroupDbg('loadGroupThreads:start', {
        silent,
        artistUserId: artistUser?.userId || null,
        activeChatTarget: activeChatTargetRef.current,
        selectedGroupThreadId: normalizeId(selectedGroupThreadIdRef.current) || null,
        groupThreadsCount: Array.isArray(groupThreadsRef.current) ? groupThreadsRef.current.length : 0,
        normalizedMessageFilter,
        roomTypeFilter: roomTypeFilter || '',
      });
      if (!artistUser?.userId) {
        artistGroupDbg('loadGroupThreads:no-artist-user');
        setGroupThreads([]);
        setSelectedGroupThreadId('');
        setGroupThreadsLoaded(false);
        return [];
      }
      if (!silent) {
        setIsLoadingGroupThreads(true);
      }
      try {
        const query = {};
        if (
          normalizedMessageFilter &&
          (!roomTypeFilter || roomTypeFilter === 'group')
        ) {
          query.message = normalizedMessageFilter;
        }
        const data = await listArtistGroupChatThreads(
          Object.keys(query).length > 0 ? query : undefined
        );
        if (data?.success === false) throw new Error(data?.message || 'fetch error');
        const list = Array.isArray(data?.threads) ? data.threads : [];
        artistGroupDbg('loadGroupThreads:success', {
          silent,
          count: list.length,
          threadIds: list.map((thread) => normalizeId(thread?.thread_id)).filter(Boolean),
        });
        setGroupThreads(list);
        return list;
      } catch (error) {
        artistGroupDbg('loadGroupThreads:error', {
          silent,
          message: error?.message || String(error),
        });
        if (!silent) {
          toastError(error?.message || 'グループチャット一覧の取得に失敗しました');
        }
        return null;
      } finally {
        artistGroupDbg('loadGroupThreads:finally', {
          silent,
          groupThreadsLoaded: true,
        });
        setGroupThreadsLoaded(true);
        if (!silent) {
          setIsLoadingGroupThreads(false);
        }
      }
    },
    [
      artistUser?.userId,
      normalizedMessageFilter,
      roomTypeFilter,
      toastError,
    ]
  );

  const loadPersonalSearchHits = useCallback(
    async (silent = false) => {
      if (!artistUser?.userId) {
        setPersonalSearchHits([]);
        return [];
      }
      if (!normalizedMessageFilter || (roomTypeFilter && roomTypeFilter !== 'personal')) {
        setPersonalSearchHits([]);
        return [];
      }
      try {
        const data = await searchArtistMessages({
          message: normalizedMessageFilter,
          limit: 200,
          offset: 0,
        });
        if (data?.success === false) throw new Error(data?.message || 'fetch error');
        const hits = Array.isArray(data?.hits) ? data.hits : [];
        setPersonalSearchHits(hits);
        return hits;
      } catch (error) {
        setPersonalSearchHits([]);
        if (!silent) {
          toastError(error?.message || 'チャット本文検索に失敗しました');
        }
        return [];
      }
    },
    [artistUser?.userId, normalizedMessageFilter, roomTypeFilter, toastError]
  );

  useEffect(() => {
    groupThreadsRef.current = groupThreads;
  }, [groupThreads]);

  const handleGroupThreadsRefresh = useCallback(
    async (silent = true) => {
      refreshPendingGroupMentionTargets();
      if (isMessageSearchActive) {
        return Promise.resolve(groupThreadsRef.current);
      }
      return loadGroupThreads(silent);
    },
    [isMessageSearchActive, loadGroupThreads, refreshPendingGroupMentionTargets]
  );

  const updateGroupThreadMeta = useCallback((threadId, patch = {}) => {
    const id = normalizeId(threadId);
    if (!id) return;
    const shouldClearRead =
      Number(patch?.unread_count) === 0 &&
      activeChatTargetRef.current === 'group' &&
      normalizeId(selectedGroupThreadIdRef.current) === id;
    if (shouldClearRead) {
      markArtistGroupThreadAsRead(id);
    }
    setGroupThreads((prev) => {
      let updated = false;
      const next = prev.map((thread) => {
        if (normalizeId(thread.thread_id) !== id) return thread;
        const merged = { ...thread, ...patch };
        if (patch.latest_message_at == null && thread.latest_message_at != null) {
          merged.latest_message_at = thread.latest_message_at;
        }
        if (patch.latest_message == null && thread.latest_message != null) {
          merged.latest_message = thread.latest_message;
        }
        if (patch.latest_message_preview == null && thread.latest_message_preview != null) {
          merged.latest_message_preview = thread.latest_message_preview;
        }
        const keys = Object.keys(patch || {});
        const changed = keys.some((key) => merged[key] !== thread[key]);
        if (!changed) return thread;
        updated = true;
        return merged;
      });
      return updated ? next : prev;
    });
  }, [markArtistGroupThreadAsRead]);

  const patchGroupThreadFromRealtime = useCallback((payload = {}) => {
    const source = normalizeRealtimePayload(payload);
    const id = normalizeId(pickRealtimeThreadId(source));
    if (!id) return;
    const latestMessage = buildRealtimeGroupThreadMessage(payload);
    const exactUnreadCount = Number(source.unreadCount ?? source.unread_count);
    setGroupThreads((prev) => {
      const index = prev.findIndex((thread) => normalizeId(thread.thread_id) === id);
      if (index < 0) return prev;
      const current = prev[index];
      const isActiveThread =
        activeChatTargetRef.current === 'group' &&
        normalizeId(selectedGroupThreadIdRef.current) === id;
      const currentUnread = Number(current?.unread_count || 0);
      const shouldIncrementUnread =
        !isActiveThread &&
        !(
          String(source.senderType || source.sender_type || source.message?.sender_type || '').trim().toLowerCase() === 'artist' &&
          normalizeId(
            source.senderId ||
              source.sender_id ||
              source.message?.artist_user_id ||
              source.message?.artistUserId
          ) === normalizeId(artistUserRef.current?.userId)
        );
      const patched = {
        ...current,
        latest_message: latestMessage,
        latest_message_at: latestMessage.created_at,
        updated_at: latestMessage.created_at,
        latest_message_preview: buildSidebarPreviewText(latestMessage),
        unread_count:
          Number.isFinite(exactUnreadCount) && exactUnreadCount >= 0
            ? Math.round(exactUnreadCount)
            : shouldIncrementUnread
              ? currentUnread + 1
              : currentUnread,
      };
      return [patched, ...prev.slice(0, index), ...prev.slice(index + 1)];
    });
  }, []);

  const handleGroupAccessLost = useCallback(
    async (threadId, message) => {
      const normalizedThreadId = normalizeId(threadId);
      artistGroupDbg('handleGroupAccessLost:start', {
        threadId: normalizedThreadId || null,
        selectedGroupThreadId: normalizeId(selectedGroupThreadId) || null,
        activeChatTarget,
        message: message || '',
      });
      const refreshedThreads = await loadGroupThreads(true);
      if (!Array.isArray(refreshedThreads)) {
        artistGroupDbg('handleGroupAccessLost:refresh-failed', {
          threadId: normalizedThreadId || null,
        });
        return;
      }
      const stillExists = Array.isArray(refreshedThreads)
        ? refreshedThreads.some((thread) => normalizeId(thread?.thread_id) === normalizedThreadId)
        : false;

      artistGroupDbg('handleGroupAccessLost:after-refresh', {
        threadId: normalizedThreadId || null,
        refreshedCount: refreshedThreads.length,
        stillExists,
        refreshedIds: refreshedThreads.map((thread) => normalizeId(thread?.thread_id)).filter(Boolean),
      });

      if (!stillExists && normalizedThreadId === normalizeId(selectedGroupThreadId)) {
        artistGroupDbg('handleGroupAccessLost:clear-selection', {
          threadId: normalizedThreadId || null,
        });
        setSelectedGroupThreadId('');
        setSelectedGroupAnchorMessageId('');
        setActiveChatTarget('');
        if (message) {
          toastError(message);
        }
        return;
      }

      if (!stillExists && message) {
        artistGroupDbg('handleGroupAccessLost:missing-thread-toast-only', {
          threadId: normalizedThreadId || null,
        });
        toastError(message);
      }
    },
    [activeChatTarget, loadGroupThreads, selectedGroupThreadId, toastError]
  );

  const handleMobileBackToTargetList = useCallback(() => {
    mobileTargetListPrefRef.current = true;
    mobileTargetChatHistoryRef.current = false;
    if (window.history.state && window.history.state.acp === 'chat') {
      try {
        window.history.back();
        return;
      } catch {}
    }
    setMobileView('list');
  }, []);

  useEffect(() => {
    if (!isGroupTarget) return;
    setIsModalOpen(false);
    setMessageMenu(null);
  }, [isGroupTarget]);

  useEffect(() => {
    artistGroupDbg('group-selection-state', {
      activeChatTarget,
      selectedGroupThreadId: normalizeId(selectedGroupThreadId) || null,
      selectedGroupAnchorMessageId: String(selectedGroupAnchorMessageId || '').trim() || null,
      groupThreadsCount: groupThreads.length,
      groupThreadsLoaded,
      isLoadingGroupThreads,
      isGroupTarget,
      showTargetSidebar,
      isMobile,
      resolvedMobileView,
    });
  }, [
    activeChatTarget,
    groupThreads.length,
    groupThreadsLoaded,
    isGroupTarget,
    isLoadingGroupThreads,
    isMobile,
    resolvedMobileView,
    selectedGroupAnchorMessageId,
    selectedGroupThreadId,
    showTargetSidebar,
  ]);

  useEffect(() => {
    artistGroupDbg('group-render-gate', {
      isTargetSelectionPending,
      isGroupTarget,
      selectedGroupThreadId: normalizeId(selectedGroupThreadId) || null,
      resolvedMobileView,
      willRenderGroupPane: !isTargetSelectionPending && isGroupTarget,
    });
  }, [
    isGroupTarget,
    isTargetSelectionPending,
    resolvedMobileView,
    selectedGroupThreadId,
  ]);

  useEffect(() => {
    if (activeChatTarget === 'group' && selectedGroupThreadId) {
      artistGroupDbg('selection-guard:keep-group-selection', {
        selectedGroupThreadId: normalizeId(selectedGroupThreadId) || null,
      });
      setSelectedPersonalAnchorMessageId('');
      return;
    }
    if (activeChatTarget !== 'group' && selectedGroupThreadId) {
      artistGroupDbg('selection-guard:clear-stale-group-selection', {
        activeChatTarget,
        selectedGroupThreadId: normalizeId(selectedGroupThreadId) || null,
      });
      setSelectedGroupThreadId('');
      setSelectedGroupAnchorMessageId('');
    }
    if (activeChatTarget !== 'personal') {
      setSelectedPersonalAnchorMessageId('');
    }
  }, [groupThreads, activeChatTarget, selectedGroupThreadId]);

  const [isUploading, setIsUploading] = useState(false);
  // ChatComposer → 送信中ローダーの受け口（画像/ファイルのみ反応。booleanのみでもOK）
  const handleUploading = useCallback((v) => {
    // 既存ChatComposerは boolean だけ渡す実装 → そのまま対応
    if (typeof v === 'boolean') {
      setIsUploading(v);
      return;
    }
    // 互換拡張: { active:boolean, kind:'text'|'file'|'images' }
    const active = !!v?.active;
    const kind = String(v?.kind || '');
    if (kind === 'file' || kind === 'images') {
      setIsUploading(active);
    } else if (!active) {
      // 明示OFFはどの種別でも止める
      setIsUploading(false);
    }
  }, []);

  useEffect(() => { isFetchingRef.current = isFetching; }, [isFetching]);

  useEffect(() => {
    if (!artistUser?.userId) {
      setGroupThreads([]);
      setPersonalSearchHits([]);
      setSelectedGroupThreadId('');
      setGroupThreadsLoaded(false);
      return undefined;
    }
    loadGroupThreads(false);
    loadPersonalSearchHits(true);
    return undefined;
  }, [artistUser?.userId, loadGroupThreads, loadPersonalSearchHits]);

  useEffect(() => {
    if (!artistUser?.userId) return undefined;
    const socket = getSocket();
    if (!socket.connected) {
      try {
        socket.connect();
      } catch (_) {}
    }

    const handleGroupMessage = (payload = {}) => {
      patchGroupThreadFromRealtime(payload);
      refreshPendingGroupMentionTargets();
    };
    const handleGroupReadUpdated = (payload = {}) => {
      const threadId = normalizeId(pickRealtimeThreadId(payload));
      if (!threadId) return;
      const readerType = String(payload?.readerType || payload?.reader_type || '').trim().toLowerCase();
      const readerId = normalizeId(payload?.readerId || payload?.reader_id);
      if (readerType !== 'artist' || !readerId || readerId !== normalizeId(artistUserRef.current?.userId)) {
        return;
      }
      updateGroupThreadMeta(threadId, { unread_count: Number.isFinite(payload.unreadCount) ? payload.unreadCount : (payload.readScope === 'topic' ? undefined : 0) });
    };

    socket.on(SOCKET_EVENTS.NEW_GROUP_CHAT_MESSAGE, handleGroupMessage);
    socket.on(SOCKET_EVENTS.GROUP_CHAT_READ_UPDATED, handleGroupReadUpdated);

    return () => {
      socket.off(SOCKET_EVENTS.NEW_GROUP_CHAT_MESSAGE, handleGroupMessage);
      socket.off(SOCKET_EVENTS.GROUP_CHAT_READ_UPDATED, handleGroupReadUpdated);
    };
  }, [
    artistUser?.userId,
    patchGroupThreadFromRealtime,
    refreshPendingGroupMentionTargets,
    updateGroupThreadMeta,
  ]);

  const isViewingLatest = () => {
    const el = chatContainerRef.current;
    if (!el) return true;
    const dir = (getComputedStyle(el).flexDirection || '').toLowerCase();
    const nearBottomNormal = (el.scrollHeight - el.clientHeight - el.scrollTop) <= 80;
    const nearBottomReverse = Math.abs(el.scrollTop) <= 80;
    return dir.includes('column-reverse') ? nearBottomReverse : nearBottomNormal;
  };

  const scrollToLatest = useCallback(() => {
    const el = chatContainerRef.current;
    if (!el) return;
    const dir = (getComputedStyle(el).flexDirection || '').toLowerCase();
    el.scrollTop = dir.includes('column-reverse') ? 0 : el.scrollHeight;
  }, []);

  const isNearTopForPaging = useCallback(() => {
    const c = chatContainerRef.current;
    if (!c) return false;
    const dir = (getComputedStyle(c).flexDirection || '').toLowerCase();
    const THRESH = 80;
    if (dir.includes('column-reverse')) {
      const maxAbs = c.scrollHeight - c.clientHeight;
      const absTop = Math.abs(c.scrollTop);
      return absTop >= (maxAbs - THRESH);
    }
    return c.scrollTop <= THRESH;
  }, []);

  const dbg = (...args) => console.log('[ChatDBG]', ...args);
  // 初期ロード完了フラグ（無限スクロールの前提）
  const [initialLoaded, setInitialLoaded] = useState(false);

  // ===== ジャンルロジック（ID配列/旧value両対応） =====
  const parsePgIntArray = (s) => {
    const t = String(s || '').trim();
    if (t.startsWith('{') && t.endsWith('}')) {
      return t
        .slice(1, -1)
        .split(',')
        .map((x) => Number(x))
        .filter(Number.isInteger);
    }
    return null;
  };
  const normalizeGenreIds = (maybeGenre) => {
    if (Array.isArray(maybeGenre)) {
      const arr = maybeGenre.map((v) => Number(v)).filter(Number.isInteger);
      return arr.length ? arr : [];
    }
    if (typeof maybeGenre === 'string' && maybeGenre.trim().startsWith('{')) {
      return parsePgIntArray(maybeGenre) || [];
    }
    if (typeof maybeGenre === 'string' && maybeGenre.trim().startsWith('[')) {
      try {
        const arr = JSON.parse(maybeGenre);
        if (Array.isArray(arr)) return arr.map((v) => Number(v)).filter(Number.isInteger);
      } catch {}
    }
    if (typeof maybeGenre === 'number') return [Number(maybeGenre)];
    if (typeof maybeGenre === 'string' && maybeGenre) return [maybeGenre]; // 旧value名（単一）
    return [];
  };
  const genresById = useMemo(() => {
    const m = new Map();
    for (const g of genres) m.set(Number(g.id), g);
    return m;
  }, [genres]);
  const genresByValueLower = useMemo(() => {
    const m = new Map();
    for (const g of genres) if (g?.value) m.set(String(g.value).toLowerCase(), g);
    return m;
  }, [genres]);
  const genresByIdRef = useRef(new Map());
  const genresByValueLowerRef = useRef(new Map());
  const resolvePrimaryGenreObj = (maybeGenre) => {
    const ids = normalizeGenreIds(maybeGenre);
    if (ids.length > 0 && Number.isInteger(ids[0])) {
      return genresById.get(Number(ids[0])) || null;
    }
    if (
      typeof maybeGenre === 'string' &&
      maybeGenre &&
      !maybeGenre.trim().startsWith('{') &&
      !maybeGenre.trim().startsWith('[')
    ) {
      return genresByValueLower.get(maybeGenre.toLowerCase()) || null;
    }
    return null;
  };
  const getGenreLabel = (maybeGenre) => resolvePrimaryGenreObj(maybeGenre)?.label ?? '';
  useEffect(() => {
    genresByIdRef.current = genresById;
    genresByValueLowerRef.current = genresByValueLower;
  }, [genresById, genresByValueLower]);

  // genres ref を参照してラベル解決するため callback 自体は固定で扱う
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getGenreLabelFromCache = useCallback((maybeGenre) => {
    const ids = normalizeGenreIds(maybeGenre);
    if (ids.length > 0 && Number.isInteger(ids[0])) {
      return genresByIdRef.current.get(Number(ids[0]))?.label ?? '';
    }
    if (
      typeof maybeGenre === 'string' &&
      maybeGenre &&
      !maybeGenre.trim().startsWith('{') &&
      !maybeGenre.trim().startsWith('[')
    ) {
      return genresByValueLowerRef.current.get(maybeGenre.toLowerCase())?.label ?? '';
    }
    return '';
  }, []);

  useEffect(() => {
    if (!isPersonalTargetActive) return;
    // §3.6: ANCHOR 窓(hasNewerMessages=true)の間は最新未到達なので既読化しない。
    if (hasNewerMessages) return;
    if (messages.length > 0 && chatContainerRef.current) {
      const atTop = isViewingLatest();
      if (!atTop) return;

      const hasUnread = messages.some(
        (m) => m.message_type === 'admin_message' && !m.is_read
      );
      if (hasUnread) {
        (async () => {
          const marked = await markMessagesAsRead();
          if (chatTopics.canClearParentUnread()) setUnreadCount(0);
          if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
          if (marked) setMessages((prev) =>
            prev.map((m) =>
              m.message_type === 'admin_message' ? { ...m, is_read: true } : m
            )
          );
          setShowNewMsgBanner(false);
        })();
      }
    }
  }, [messages, isPersonalTargetActive, hasNewerMessages, setArtistMessageCount]);

  const fetchGenres = async () => {
    try {
      const data = await listGenres();
      setGenres(normalizeGenresPayload(data));
    } catch (error) {
      console.error('Error fetching genres:', error);
      toastError('ジャンルの取得に失敗しました。');
    }
  };

  // お知らせ系かどうか
  const isNoticeFormat = (fmt) =>
    [
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_CANCELLED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_DECLINE,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_CANCEL_COMP_DECIDED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_CANCELLED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_UPDATED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONCIERGE_RESULT,
      ADMIN_MESSAGE_FORMATS.ADDITIONAL_REWARD_OFFER, ADMIN_MESSAGE_FORMATS.ANNOUNCE_ADDITIONAL_PAYMENT_CANCELLED, ADMIN_MESSAGE_FORMATS.ADDITIONAL_REWARD_CLAIM_COMPLETED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_ASSIGNED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_CHANGED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_UNASSIGNED,
      ADMIN_MESSAGE_FORMATS.ANNOUNCE_STAGE_SEATING_SHARED,
      ADMIN_MESSAGE_FORMATS.REMINDER_NOTICE,
    ].includes(fmt) || isInvoiceResubmissionRequestedFormat(fmt);
  const PART_NOTICE_FORMATS = [ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_ASSIGNED,
    ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_CHANGED,
    ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_UNASSIGNED,
  ];
  const isSystemFormat = (fmt) =>
    fmt &&
    fmt !== ADMIN_MESSAGE_FORMATS.TEXT &&
    fmt !== ADMIN_MESSAGE_FORMATS.IMAGE &&
    fmt !== ADMIN_MESSAGE_FORMATS.FILE;

  const canUnsendMessage = useCallback(
    (message) => {
      if (isReadOnly) return false;
      if (!message) return false;
      if (message.message_type !== 'artist_message') return false;
      const artistId = artistUser?.userId ?? artistUser?.id ?? null;
      if (artistId && String(message.artist_id) !== String(artistId)) return false;
      if (!UNSENDABLE_FORMATS.has(message.message_format)) return false;
      return isWithinHoursFromNow(message.created_at, 1);
    },
    [isReadOnly, artistUser],
  );

  const canAnnouncementMessage = useCallback((message) => {
    if (!message) return false;
    return UNSENDABLE_FORMATS.has(message.message_format);
  }, []);

  const canReactMessage = useCallback((message) => {
    if (!message || !supportsChatMessageReaction(message)) return false;
    return String(message.message_type || '').trim() !== 'artist_message';
  }, []);

  const canReplyMessage = useCallback((message) => {
    if (!message) return false;
    const type = String(message.message_type || '').trim();
    const format = String(message.message_format || '').trim().toLowerCase();
    return ['admin_message', 'artist_message'].includes(type) && ['text', 'image', 'file'].includes(format);
  }, []);

  const canCopyMessage = useCallback((message) => hasCopyableChatMessageText(message), []);

  const canOpenMessageMenu = useCallback(
    (message) =>
      canCopyMessage(message) ||
      canReplyMessage(message) ||
      canUnsendMessage(message) ||
      canAnnouncementMessage(message) ||
      canReactMessage(message),
    [canAnnouncementMessage, canCopyMessage, canReactMessage, canReplyMessage, canUnsendMessage],
  );

  const { menuRef: messageMenuRef, resolveMenuPosition } = useViewportBoundedMenuPosition({
    menu: messageMenu,
    setMenu: setMessageMenu,
    padding: 12,
    fallbackWidth: 248,
    fallbackHeight: 360,
  });

  const closeMessageMenu = useCallback(() => {
    setMessageMenu(null);
  }, []);

  const closePartialCopyMode = useCallback(() => {
    setInlineCopyMessageId('');
  }, []);
  const openMessageMenuAt = useCallback(
    (message, x, y) => {
      if (!message) return;
      const pos = resolveMenuPosition(x, y);
      setMessageMenu({ message, x: pos.x, y: pos.y });
    },
    [resolveMenuPosition],
  );

  const clearMessageLongPress = useCallback(() => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
  }, []);

  const handleMessageContextMenu = useCallback(
    (event, message) => {
      if (!canOpenMessageMenu(message)) return;
      event.preventDefault();
      openMessageMenuAt(message, event.clientX, event.clientY);
    },
    [canOpenMessageMenu, openMessageMenuAt],
  );

  const handleMessageTouchStart = useCallback(
    (event, message) => {
      if (!canOpenMessageMenu(message)) return;
      clearMessageLongPress();
      const touch = event.touches?.[0];
      if (!touch) return;
      const { clientX, clientY } = touch;
      longPressTimerRef.current = setTimeout(() => {
        openMessageMenuAt(message, clientX, clientY);
      }, 550);
    },
    [clearMessageLongPress, openMessageMenuAt, canOpenMessageMenu],
  );

  const handleUnsendMessage = useCallback(async () => {
    const target = messageMenu?.message;
    if (!target) return;
    closeMessageMenu();
    try {
      const data = await deleteArtistMessage(String(target.id));
      const deletedIds = Array.isArray(data?.messageIds) && data.messageIds.length
        ? data.messageIds.map((id) => String(id))
        : [String(target.id)];
      setMessages((prev) => removeMessages(prev, deletedIds));
    } catch (err) {
      if (toastError) toastError(err?.message || '送信取り消しに失敗しました。');
    }
  }, [messageMenu, closeMessageMenu, toastError]);

  const handleToggleAnnouncementMessage = useCallback(async () => {
    const target = messageMenu?.message;
    if (!target) return;
    closeMessageMenu();
    try {
      if (isAnnouncedMessage(target.id)) {
        await unpinAnnouncement(target.id);
      } else {
        await pinAnnouncement(target.id);
      }
    } catch (_) {}
  }, [closeMessageMenu, isAnnouncedMessage, messageMenu, pinAnnouncement, unpinAnnouncement]);

  const handleMessageMenuReactionSelect = useCallback(async (messageId, reactionType) => {
    closeMessageMenu();
    try {
      await toggleReaction(messageId, reactionType);
    } catch (_) {}
  }, [closeMessageMenu, toggleReaction]);

  const handleCopyMessage = useCallback(async () => {
    const target = messageMenu?.message;
    if (!target) return;
    const copyText = resolveCopyableChatMessageText(target);
    closeMessageMenu();
    if (!copyText) {
      toastError?.('コピーできる本文がありません。');
      return;
    }
    try {
      await writeTextToClipboard(copyText);
      toastSuccess?.('メッセージをコピーしました。');
    } catch (error) {
      toastError?.(error?.message || 'コピーに失敗しました。');
    }
  }, [closeMessageMenu, messageMenu, toastError, toastSuccess]);

  const handleOpenInlinePartialCopy = useCallback(() => {
    const target = messageMenu?.message;
    if (!target) return;
    const copyText = resolveCopyableChatMessageText(target);
    closeMessageMenu();
    if (!copyText) {
      toastError?.('コピーできる本文がありません。');
      return;
    }
    const nextMessageId = String(target.id || '').trim();
    setInlineCopyMessageId((current) => (current === nextMessageId ? '' : nextMessageId));
  }, [closeMessageMenu, messageMenu, toastError]);

  const handleCopySelectionText = useCallback(async (selectedText) => {
    if (!String(selectedText || '').trim()) {
      toastError?.('コピーしたい範囲を選択してください。');
      return;
    }
    try {
      await writeTextToClipboard(selectedText);
      toastSuccess?.('選択範囲をコピーしました。');
    } catch (error) {
      toastError?.(error?.message || 'コピーに失敗しました。');
    }
  }, [toastError, toastSuccess]);

  const renderPartialCopyContent = useCallback((message, contentNode, isSelfMessage = false) => {
    const normalizedMessageId = String(message?.id || '').trim();
    if (!normalizedMessageId || !canCopyMessage(message)) return contentNode;
    return (
      <ChatMessageSelectableCopyArea
        active={inlineCopyMessageId === normalizedMessageId}
        messageId={normalizedMessageId}
        copyButtonSide={isSelfMessage ? 'left' : 'right'}
        onDeactivate={closePartialCopyMode}
        onCopySelection={handleCopySelectionText}
      >
        {contentNode}
      </ChatMessageSelectableCopyArea>
    );
  }, [canCopyMessage, closePartialCopyMode, handleCopySelectionText, inlineCopyMessageId]);

  const buildReplyDraftFromMessage = useCallback((message) => buildArtistChatReplyDraft(message, artistUser), [artistUser]);

  const handleSelectReplyMessage = useCallback(() => {
    const target = messageMenu?.message;
    if (!target) return;
    closeMessageMenu();
    const draft = buildReplyDraftFromMessage(target);
    selectTopicForReply(chatTopics, target, draft);
    setReplyDraft(draft);
  }, [buildReplyDraftFromMessage, closeMessageMenu, messageMenu]);

  const handleSelectAnnouncementMessage = async (messageId) => {
    const normalizedMessageId = String(messageId || '').trim();
    if (!normalizedMessageId) return;
    setIsAnnouncementListOpen(false);
    await fetchInitialMessages(true, { anchorMessageId: normalizedMessageId });
  };

  const handleJumpToReplyMessage = useTopicReplyNavigation(chatTopics, toastError);

  const ensureReminderSchedule = useCallback(
    async (scheduleId) => {
      if (!scheduleId) return null;
      if (reminderCacheRef.current.has(scheduleId)) {
        return reminderCacheRef.current.get(scheduleId);
      }
      try {
        const sched = await getReminderSchedule(scheduleId);
        reminderCacheRef.current.set(scheduleId, sched);
        setReminderCacheVersion((v) => v + 1);
        return sched;
      } catch (_) {
        reminderCacheRef.current.set(scheduleId, null);
        setReminderCacheVersion((v) => v + 1);
        return null;
      }
    },
    [],
  );

  const parseReminderContent = (message) => {
    const cleaned = sanitizeReminderContent(message?.content || '');
    const { scheduleId: parsedId, kind: parsedKind } = parseReminderTags(message?.content || '');
    const scheduleId = message?.reminder_schedule_id || parsedId;
    const kind = message?.reminder_kind || parsedKind;
    const schedFromMsg = {
      event_uuid: message?.reminder_event_uuid || null,
      event_name: message?.reminder_event_name || null,
      event_performance_type: message?.reminder_event_performance_type || null,
      schedule_date: message?.reminder_schedule_date || null,
      start_time: message?.reminder_start_time || null,
      end_time: message?.reminder_end_time || null,
      note: message?.reminder_note || null,
      place_name: message?.reminder_place_name || null,
      place_address: message?.reminder_place_address || null,
    };
    const hasSchedFromMsg = Object.values(schedFromMsg).some((v) => v != null);
    const sched = hasSchedFromMsg
      ? schedFromMsg
      : scheduleId
        ? reminderCacheRef.current.get(scheduleId)
        : null;

    const lines = cleaned
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter(Boolean);

    const eventTitle = sched?.event_name || lines[0] || '';
    const eventPerf  = sched?.event_performance_type || '';
    let scheduleTitle = sched?.note || '';
    let dateTime = '';
    let place = '';

    const isDateLine = (line) => /^\d{4}-\d{2}-\d{2}/.test(line);

    for (const line of lines.slice(1)) {
      if (!dateTime && isDateLine(line)) {
        dateTime = line;
        continue;
      }
      if (!place && line.includes('/')) {
        place = line;
        continue;
      }
      if (!scheduleTitle) {
        scheduleTitle = line;
      }
    }

    if (!scheduleTitle) scheduleTitle = 'スケジュール';

    if (sched) {
      const date = sched.schedule_date ? toYmdSlash(sched.schedule_date) : '';
      const start = sched.start_time ? toHHmm(sched.start_time) : '';
      const end = sched.end_time ? toHHmm(sched.end_time) : '';
      dateTime = [date, [start, end].filter(Boolean).join('〜')].filter(Boolean).join(' ');
      const placeBits = [sched.place_name, sched.place_address].filter(Boolean);
      place = placeBits.join(' / ');
    }

    return { eventTitle, eventPerf, scheduleTitle, dateTime, place, scheduleId, kind, schedule: sched };
  };

  const normalizeBooleanFlag = (value) => {
    if (typeof value === 'boolean') return value;
    const normalized = String(value ?? '').trim().toLowerCase();
    return ['1', 'true', 'yes', 'on'].includes(normalized);
  };

  const collectFlyerUuidQueue = useCallback((message) => {
    if (!message) return [];
    const fmt = message.message_format;
    const isHold = isHoldAnnouncementFormat(fmt);
    const useExisting =
      normalizeBooleanFlag(
        isHold ? message.event_use_existing_flyers : message.contract_event_use_existing_flyers
      ) || false;
    const originalUuid =
      message.event_original_event_uuid ||
      message.contract_event_original_event_uuid ||
      message.event_original_eventUuid ||
      message.contract_event_original_eventUuid ||
      '';
    const baseUuid = isHold ? message.base_event_uuid : message.contract_base_event_uuid;
    const fallbackBaseUuid = message.base_event_uuid || message.contract_base_event_uuid;
    const eventUuid = isHold ? message.event_uuid : message.contract_event_uuid;

    const candidates = [
      useExisting ? originalUuid : null,
      isHold && message.is_multiple_events ? baseUuid : null,
      !isHold && message.contract_is_multi ? (message.contract_base_event_uuid || message.base_event_uuid) : null,
      eventUuid,
      baseUuid,
      fallbackBaseUuid,
      message.event_uuid,
      message.contract_event_uuid,
      originalUuid,
    ];
    return Array.from(new Set(candidates.filter(Boolean)));
  }, []);

  const getEventDetailCached = useCallback(
    async (eventUuid) => {
      if (!eventUuid) return null;
      if (eventDetailCacheRef.current.has(eventUuid)) {
        return eventDetailCacheRef.current.get(eventUuid);
      }
      if (eventDetailInflightRef.current.has(eventUuid)) {
        return eventDetailInflightRef.current.get(eventUuid);
      }
      const request = getEventDetail(eventUuid)
        .catch(() => null)
        .finally(() => {
          eventDetailInflightRef.current.delete(eventUuid);
        });
      eventDetailInflightRef.current.set(eventUuid, request);
      const detail = await request;
      if (detail) {
        eventDetailCacheRef.current.set(eventUuid, detail);
      }
      return detail;
    },
    [],
  );

  const pickFlyerFilename = (message) => {
    if (!message) return '';
    const fmt = message.message_format;
    const isHold = isHoldAnnouncementFormat(fmt);
    const candidates = [
      // マルチイベントは基底イベントを最優先
      isHold && message.is_multiple_events ? message.base_event_flyer_front_url : null,
      !isHold && message.contract_is_multi ? message.contract_base_event_flyer_front_url : null,
      isHold ? message.event_flyer_front_url : message.contract_event_flyer_front_url,
      isHold ? message.base_event_flyer_front_url : message.contract_base_event_flyer_front_url,
      message.flyer_front_url,
    ];
    return candidates.find((v) => !!v) || '';
  };

  const ensureFlyerUrl = useCallback(
    async (message) => {
      if (
        !message ||
        ![
          ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD,
          ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_CANCELLED,
          ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT,
          ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_CANCELLED,
          ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_UPDATED,
        ].includes(message.message_format)
      ) {
        return null;
      }

      const cacheKey = String(message.id || `${message.message_format}-${message.created_at}`);
      if (flyerCacheRef.current.has(cacheKey)) {
        return flyerCacheRef.current.get(cacheKey);
      }

      const direct = pickFlyerFilename(message);
      if (direct) {
        const url = buildFlyerUrl(direct);
        flyerCacheRef.current.set(cacheKey, url);
        setFlyerCacheVersion((v) => v + 1);
        return url;
      }

      const queue = collectFlyerUuidQueue(message);
      const visited = new Set();
      while (queue.length) {
        const targetUuid = queue.shift();
        if (!targetUuid || visited.has(targetUuid)) continue;
        visited.add(targetUuid);

        const detail = await getEventDetailCached(targetUuid);
        if (!detail) continue;
        const remoteFlyer =
          detail.flyer_front_url || detail.flyer_front || detail.event?.flyer_front_url || detail.event?.flyer_front;
        if (remoteFlyer) {
          const url = buildFlyerUrl(remoteFlyer);
          flyerCacheRef.current.set(cacheKey, url);
          setFlyerCacheVersion((v) => v + 1);
          return url;
        }

        const parentUuid =
          detail.original_event_uuid ||
          detail.originalEventUuid ||
          detail.event?.original_event_uuid ||
          detail.event?.originalEventUuid ||
          null;
        const wantsParent =
          normalizeBooleanFlag(
            detail.use_existing_flyers ??
              detail.useExistingFlyers ??
              detail.event?.use_existing_flyers ??
              detail.event?.useExistingFlyers ??
              false,
          );
        if (wantsParent && parentUuid && !visited.has(parentUuid)) {
          queue.push(parentUuid);
        }
      }

      flyerCacheRef.current.set(cacheKey, null);
      setFlyerCacheVersion((v) => v + 1);
      return null;
    },
    [getEventDetailCached],
  );

  const getCachedFlyerUrl = useCallback(
    (cacheKey) => flyerCacheRef.current.get(cacheKey),
    [],
  );

  useEffect(() => {
    const targets = messages.filter((m) =>
      [
        ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD,
        ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_CANCELLED,
        ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT,
        ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_CANCELLED,
        ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_UPDATED,
      ].includes(m.message_format),
    );
    targets.forEach((m) => {
      const key = String(m.id || `${m.message_format}-${m.created_at}`);
      if (!flyerCacheRef.current.has(key)) {
        ensureFlyerUrl(m);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, ensureFlyerUrl]);

  useEffect(() => {
    const ids = messages
      .filter((m) => m.message_format === ADMIN_MESSAGE_FORMATS.REMINDER_NOTICE)
      .map((m) => m.reminder_schedule_id || parseReminderTags(m.content).scheduleId)
      .filter(Boolean);
    ids.forEach((id) => {
      if (!reminderCacheRef.current.has(id)) ensureReminderSchedule(id);
    });
  }, [messages, ensureReminderSchedule]);

  // アバター
  const getAdminDisplayName = (m) => {
    if (!m || m.message_type !== 'admin_message') return '';
    const name = m.is_nickname_allowed
      ? (m.admin_nickname || m.admin_full_name || '')
      : (m.admin_full_name || m.admin_nickname || '');
    return name || m.admin_email || '';
  };
  const buildAdminProfile = (admin) => {
    if (!admin) return null;
    const name = firstNonEmpty(
      admin.admin_name,
      admin.admin_full_name,
      admin.display_name,
      admin.full_name,
      admin.admin_username,
      admin.username,
      admin.admin_nickname,
      admin.nickname,
      admin.fullName,
      admin.name,
    );
    if (!name) return null;
    return buildAdminProfileForModal({
      admin: {
        ...admin,
        display_name: name,
        full_name: name,
        nickname: admin.admin_nickname || admin.nickname || admin.display_name_sub || '',
        position: admin.admin_position || admin.position || '',
        department: admin.admin_department || admin.department || '',
        profile_one_liner: firstNonEmpty(
          admin.admin_profile_one_liner,
          admin.admin_comment,
          admin.admin_note,
          admin.comment
        ),
        profile_picture:
          admin.admin_profile_picture || admin.picture || admin.profile_picture || admin.pic || '',
      },
    });
  };
  const openAdminProfile = (admin) => {
    const profile = buildAdminProfile(admin);
    if (!profile) return;
    openAdminProfileState(profile);
  };
  const handleMentionClick = useCallback((mention = {}) => {
    if (normalizeMentionTargetType(mention) !== 'person') return;
    const role = normalizeMentionTargetRole(mention);
    if (role !== 'admin') return;
    const targetId = normalizeMentionTargetId(mention);
    const label = normalizeMentionLabel(mention?.label || mention?.displayLabel);
    if (!targetId && !label) return;
    const candidate = targetId ? personalMentionCandidateLookup.get(`admin:${targetId}`) : null;
    openAdminProfile({
      id: targetId,
      admin_user_id: targetId,
      display_name: candidate?.label || label || '管理者',
      full_name: candidate?.label || label || '',
      profile_picture_url: candidate?.avatarUrl || '',
      position: candidate?.subtitle || '',
    });
  }, [openAdminProfile, personalMentionCandidateLookup]);

  const renderAdminAvatar = (message) => {
    if (message.message_type !== 'admin_message') return null;
    if (isNoticeFormat(message.message_format)) {
      const toneClass = getSystemToneClass(message);
      const avatarClassName = toneClass
        ? `chat-avatar chat-avatar-announce ${toneClass}`
        : 'chat-avatar chat-avatar-announce';
      return (
        <div className={avatarClassName} title="お知らせ">
          <i className="fa-solid fa-bullhorn" aria-hidden="true" />
        </div>
      );
    }
    const name = getAdminDisplayName(message);
    const profile = buildAdminProfile(message);
    const isClickable = !!profile;
    return (
      <EventChatAvatarNode
        role="admin"
        className="chat-avatar"
        clickableClassName="chat-avatar--clickable"
        name={name}
        picture={message.admin_profile_picture || ''}
        imageRoot={ADMIN_PROFILE_IMAGE_PATH}
        buildAssetUrl={buildAssetUrl}
        appendVariant={appendVariant}
        showAdminIdentityBadge
        onClick={isClickable ? () => openAdminProfile(message) : undefined}
      />
    );
  };

  /** 最新優先で ID マージ（競合は additions で上書き、降順ソート） */
  // Anchored Timeline v1 §3.2: 共通 timelineMerge へ委譲(DESC・id一意・後勝ち・参照安定)。
  // 全流入(初期/older/newer/socket/差分)がこの1関数を通る単一マージ契約。
  const mergeMessagesByIdDesc = (prev, additions) => mergeMessages(prev, additions);

  /** 配列から最古(created_atが最も小さい)のレコードの created_at を返す */
  const pickOldestCreatedAt = (arr = []) => {
    let winner = null;
    for (const m of arr) {
      if (!m || !m.created_at) continue;
      if (!winner) { winner = m.created_at; continue; }
      if (new Date(m.created_at) < new Date(winner)) winner = m.created_at;
    }
    return winner;
  };

  // メッセージ整形は周辺 helper と一体で保持している
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const mapMessagesForDisplay = (rawMessages = []) =>
    (Array.isArray(rawMessages) ? rawMessages : [])
      .filter(
        (message) =>
          message.content !== null ||
          message.image_id !== null ||
          [
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD,
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_CANCELLED,
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT,
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_CANCELLED,
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_UPDATED,
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONCIERGE_RESULT,
            ...PART_NOTICE_FORMATS,
            ADMIN_MESSAGE_FORMATS.ANNOUNCE_STAGE_SEATING_SHARED,
            ADMIN_MESSAGE_FORMATS.REMINDER_NOTICE,
          ].includes(message.message_format),
      )
      .map((message) => ({
        ...message,
        className: getMessageClass(message),
        genreLabel:
          isHoldAnnouncementFormat(message.message_format)
            ? getGenreLabel(message.event_genre)
            : undefined,
      }));

  // 初回取得は現在の表示 window をまとめて置き換えるため mount 時基準で扱う
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchInitialMessages = async (isNewChat = false, { anchorMessageId = '' } = {}) => {
    if (!isNewChat) return;
    const normalizedAnchorMessageId = String(anchorMessageId || '').trim();

    setIsInitialLoading(true);
    setIsFetching(true);
    try {
      try {
        const data = normalizedAnchorMessageId
          ? await listArtistMessagesAround(normalizedAnchorMessageId, 25, 25)
          : await listArtistMessages(0, limit);
        // ★ 生データ（サーバー返却そのまま）
        const raw = Array.isArray(data.messages) ? data.messages : [];

        // 画面に出すものだけフィルタ＆整形
        const messagesWithClassNames = mapMessagesForDisplay(raw);
        setMessages(messagesWithClassNames);

        if (normalizedAnchorMessageId) {
          const windowOffset = Number(data?.offset || 0);
          setSelectedPersonalAnchorMessageId(normalizedAnchorMessageId);
          setHasMore(!!data?.hasOlder);
          setHasNewerMessages(!!data?.hasNewer);
          setMessageWindowOffset(windowOffset);
          focusChatAnchorMessage({
            messageId: normalizedAnchorMessageId,
            containerRef: chatContainerRef,
            setActiveAnchorMessageId,
            timerRef: anchorHighlightTimerRef,
            behavior: 'auto',
          });
        } else {
          // ★ hasMore は “フィルタ後” ではなく “APIの生配列長” で判定
          setSelectedPersonalAnchorMessageId('');
          setHasMore(raw.length === limit);
          setHasNewerMessages(false);
          setMessageWindowOffset(0);
          setActiveAnchorMessageId('');
        }

        // ★ 次のカーソルは安全側に：生配列最古 vs 表示配列最古 の “より古い方”
        const oldestFromRaw = pickOldestCreatedAt(raw);
        const oldestFromMerged = messagesWithClassNames.length
          ? messagesWithClassNames[messagesWithClassNames.length - 1].created_at
          : null;
        let nextCursor = null;
        if (oldestFromRaw && oldestFromMerged) {
          nextCursor = new Date(oldestFromRaw) < new Date(oldestFromMerged) ? oldestFromRaw : oldestFromMerged;
        } else {
          nextCursor = oldestFromRaw || oldestFromMerged || null;
        }
        setOldestCursor(nextCursor);

        const unreadMessages = messagesWithClassNames.filter(message => message.message_type === 'admin_message' && !message.is_read).length;
        setUnreadCount(unreadMessages);
        if (isPersonalTargetActiveRef.current && !chatTopics.selected) {
          setArtistMessageCount(unreadMessages);
        }
      } catch (error) {
        if (error && typeof error === 'object' && normalizedAnchorMessageId) {
          error.status = error.status || error.response?.status;
        }
        throw error;
      }
    } catch (error) {
      if (isTopicRequestSuperseded(error)) return;
      if (normalizedAnchorMessageId && Number(error?.status) === 404) {
        try {
          const fallbackData = await listArtistMessages(0, limit);
          const raw = Array.isArray(fallbackData.messages) ? fallbackData.messages : [];
          const messagesWithClassNames = mapMessagesForDisplay(raw);
          setMessages(messagesWithClassNames);
          const oldestFromRaw = pickOldestCreatedAt(raw);
          const oldestFromMerged = messagesWithClassNames.length
            ? messagesWithClassNames[messagesWithClassNames.length - 1].created_at
            : null;
          let nextCursor = null;
          if (oldestFromRaw && oldestFromMerged) {
            nextCursor =
              new Date(oldestFromRaw) < new Date(oldestFromMerged)
                ? oldestFromRaw
                : oldestFromMerged;
          } else {
            nextCursor = oldestFromRaw || oldestFromMerged || null;
          }
          setOldestCursor(nextCursor);
          setSelectedPersonalAnchorMessageId('');
          setHasMore(raw.length === limit);
          setHasNewerMessages(false);
          setMessageWindowOffset(0);
          setActiveAnchorMessageId('');
          const unreadMessages = messagesWithClassNames.filter(
            (message) => message.message_type === 'admin_message' && !message.is_read
          ).length;
          setUnreadCount(unreadMessages);
          if (isPersonalTargetActiveRef.current && !chatTopics.selected) {
            setArtistMessageCount(unreadMessages);
          }
          toastError('対象メッセージが見つからないため、最新メッセージを表示しました。');
          return;
        } catch {}
      }
      console.error('Error fetching messages:', error);
      toastError('メッセージの取得に失敗しました。');
    } finally {
      setIsFetching(false);
      setIsInitialLoading(false);
    }
  };

  // 最新の取得関数だけ ref に同期する
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchInitialMessagesRef.current = fetchInitialMessages;
  }, [fetchInitialMessages]);

  // NOTE(§4.1.2): 旧 scheduleRealtimeMessageReconcile(700ms 後の最新ページ再取得 merge)は廃止。
  // socket 受信は enriched=直接 merge / skeleton=new-messages 差分 fetch の 2 経路に集約。

  // 過去ログ読込は現在のスクロール window を優先する
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchOlderMessages = useCallback(async () => {
    let effectiveCursor = oldestCursor;
    if (!effectiveCursor && messages.length) {
      effectiveCursor = messages[messages.length - 1]?.created_at || null;
      if (effectiveCursor) setOldestCursor(effectiveCursor);
    }

    if (isFetchingRef.current || !hasMore) {
      dbg('fetchOlderMessages: skip', {
        fetching: isFetchingRef.current,
        hasMore,
        oldestCursor,
        derivedCursor: effectiveCursor,
        msgLen: messages.length,
      });
      return;
    }

    const c = chatContainerRef.current;
    // アンカー記録
    let anchorId = null;
    let anchorTop = 0;
    if (c) {
      const cRect = c.getBoundingClientRect();
      const rows = Array.from(c.querySelectorAll('[data-mid]'));
      const firstVisible = rows.find(el => el.getBoundingClientRect().top >= cRect.top - 1);
      if (firstVisible) {
        anchorId = firstVisible.getAttribute('data-mid');
        anchorTop = firstVisible.getBoundingClientRect().top;
      }
    }

    dbg('fetchOlderMessages: start', { oldestCursor: effectiveCursor, limit, anchorId });
    isFetchingRef.current = true;
    setIsFetching(true);
    setLoadingOlderMessages(true);
    try {
      if (!effectiveCursor) return;
      dbg('fetchOlderMessages: GET', { beforeCreatedAt: effectiveCursor, limit });
      const data = await listArtistMessagesBefore(effectiveCursor, limit);

      // ★ 生配列
      const rawOlder = Array.isArray(data.messages) ? data.messages : [];

      // 画面表示用に整形
      const older = mapMessagesForDisplay(rawOlder);

      dbg('fetchOlderMessages: received', { count: older.length, rawCount: rawOlder.length });

      const orderedOlder = older.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      let nextOldestCursor = oldestCursor;
      setMessages((prev) => {
        const merged = mergeMessagesByIdDesc(prev, orderedOlder);
        nextOldestCursor = merged.length ? merged[merged.length - 1].created_at : null;
        return merged;
      });

      // ★ hasMore は生配列長で判定（ここが肝）
      setHasMore(rawOlder.length === limit);

      // ★ 次カーソルは “より古い方”
      const oldestFromRaw = pickOldestCreatedAt(rawOlder);
      if (oldestFromRaw && nextOldestCursor) {
        setOldestCursor(new Date(oldestFromRaw) < new Date(nextOldestCursor) ? oldestFromRaw : nextOldestCursor);
      } else {
        setOldestCursor(oldestFromRaw || nextOldestCursor || null);
      }

      dbg('fetchOlderMessages: merged', { nextOldestCursor, hasMore: rawOlder.length === limit });

      // スクロール補正
      requestAnimationFrame(() => {
        if (!c || !anchorId) return;
        const sameRow = c.querySelector(`[data-mid="${anchorId}"]`);
        if (!sameRow) return;
        const newTop = sameRow.getBoundingClientRect().top;
        const dy = newTop - anchorTop;
        // §4.1.3: column-reverse の標準アンカリングで通常 dy≈0。実測残差が 1px 超のときのみ補正。
        if (Math.abs(dy) > 1) c.scrollTop += dy;
      });
    } catch (err) {
      if (isTopicRequestSuperseded(err)) return;
      console.error('Error fetching older messages:', err);
      toastError('メッセージの取得に失敗しました。');
    } finally {
      setLoadingOlderMessages(false);
      setIsFetching(false);
      isFetchingRef.current = false;
    }
  }, [
    API_URL,
    hasMore,
    mapMessagesForDisplay,
    messages.length,
    oldestCursor,
    toastError,
    limit,
  ]);

  // newer 読込は現在の表示 window を優先する
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadNewerMessages = useCallback(async () => {
    if (
      isFetchingRef.current ||
      loadingNewerMessages ||
      !hasNewerMessages
    ) {
      return;
    }

    const nextOffset = Math.max(0, messageWindowOffset - limit);
    const fetchLimit = Math.max(1, messageWindowOffset - nextOffset);
    const c = chatContainerRef.current;
    let anchorId = null;
    let anchorTop = 0;
    if (c) {
      const cRect = c.getBoundingClientRect();
      const rows = Array.from(c.querySelectorAll('[data-mid]'));
      const firstVisible = rows.find((el) => el.getBoundingClientRect().top >= cRect.top - 1);
      if (firstVisible) {
        anchorId = firstVisible.getAttribute('data-mid');
        anchorTop = firstVisible.getBoundingClientRect().top;
      }
    }

    setLoadingNewerMessages(true);
    try {
      const data = await listArtistMessages(nextOffset, fetchLimit);
      const newer = mapMessagesForDisplay(data.messages || []);
      setMessages((prev) => mergeMessagesByIdDesc(prev, newer));
      setMessageWindowOffset(nextOffset);
      setHasNewerMessages(nextOffset > 0);

      requestAnimationFrame(() => {
        if (!c || !anchorId) return;
        const sameRow = c.querySelector(`[data-mid="${anchorId}"]`);
        if (!sameRow) return;
        const newTop = sameRow.getBoundingClientRect().top;
        const dy = newTop - anchorTop;
        // §4.1.3: column-reverse の標準アンカリングで通常 dy≈0。実測残差が 1px 超のときのみ補正。
        if (Math.abs(dy) > 1) c.scrollTop += dy;
      });
    } catch (error) {
      if (isTopicRequestSuperseded(error)) return;
      console.error('Error fetching newer messages:', error);
      toastError('メッセージの取得に失敗しました。');
    } finally {
      setLoadingNewerMessages(false);
    }
  }, [
    hasNewerMessages,
    limit,
    loadingNewerMessages,
    mapMessagesForDisplay,
    messageWindowOffset,
    toastError,
  ]);

  const shouldMarkRead = (atBottom) => canMarkArtistChatRead({
    isPersonalTargetActive, isPageVisible, atBottom, hasNewerMessages, unreadCount,
  });

  chatTopics.onParentUnread = setUnreadCount;
  const markMessagesAsRead = async () => {
    if (!isMountedRef.current || !isPageVisibleRef.current || !isPersonalTargetActiveRef.current) return;
    try {
      return await chatTopics.markRead();
    } catch (err) {
      console.error('[Debug] markMessagesAsRead error', err);
    }
  };

  // スクロール中は unread / paging state を優先して判定する
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = useCallback(() => {
    const c = chatContainerRef.current;
    if (!c) return;
    if (!initialLoaded) return;

    const needOld = isNearTopForPaging();
    if (needOld && hasMore && !isFetchingRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = c;
      dbg('handleScroll: trigger fetchOlder', {
        scrollTop,
        scrollHeight,
        clientHeight,
        hasMore,
        fetching: isFetchingRef.current,
        oldestCursor,
      });
      fetchOlderMessages();
    }

    const atBottom = isViewingLatest();
    if (
      hasNewerMessages &&
      !loadingNewerMessages &&
      atBottom
    ) {
      loadNewerMessages();
    }

    if (shouldMarkRead(atBottom)) {
      markMessagesAsRead().then((marked) => {
        if (!marked) return;
        if (chatTopics.canClearParentUnread()) setUnreadCount(0);
        if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
        setMessages(prev =>
          prev.map(m =>
            m.message_type === 'admin_message' ? { ...m, is_read:true } : m
          )
        );
      });
    }
  }, [
    fetchOlderMessages,
    hasMore,
    hasNewerMessages,
    initialLoaded,
    isNearTopForPaging,
    isPersonalTargetActive,
    isPageVisible,
    loadNewerMessages,
    loadingNewerMessages,
    shouldMarkRead,
  ]);

  useEffect(() => {
    const chatContainer = chatContainerRef.current;
    if (chatContainer) {
      chatContainer.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (chatContainer) {
        chatContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  const getMessageClass = (message) => {
    const classes = [];
    const system = isSystemFormat(message.message_format);
    if (system) {
      classes.push('system-message');
    } else {
      classes.push(
        message.message_type === 'admin_message'
          ? 'admin-message'
          : 'artist-message'
      );
    }

    if (isHoldAnnouncementFormat(message.message_format)) {
      classes.push('announce-hold-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT) {
      classes.push('announce-contract-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_CANCELLED) {
      classes.push('announce-contract-cancelled-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONTRACT_UPDATED) {
      classes.push('announce-contract-updated-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_DECLINE) {
      classes.push('announce-hold-decline-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.ANNOUNCE_CONCIERGE_RESULT) {
      classes.push('announce-concierge-result-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.ANNOUNCE_CANCEL_COMP_DECIDED) {
      classes.push('announce-cancel-comp-decided-message');
    }
    if (isInvoiceResubmissionRequestedFormat(message.message_format)) {
      classes.push('announce-cancel-comp-decided-message');
    }
    if (isPartAnnouncementFormat(message.message_format)) {
      classes.push('announce-part-assigned-message');
    }
    if (isStageSeatingShareAnnouncementFormat(message.message_format)) {
      classes.push('announce-stage-seating-shared-message');
    }
    if (message.message_format === ADMIN_MESSAGE_FORMATS.REMINDER_NOTICE) {
      classes.push('reminder-notice-message');
    }

    return appendBubbleFormatClassName(classes.join(' '), message.message_format);
  };

  // 画像プレビュー用
  const imageMessages = useMemo(
    () => messages.filter((message) => message.message_format === ADMIN_MESSAGE_FORMATS.IMAGE && message.image_file_name),
    [messages],
  );
  const imagePreviewUrls = useMemo(
    () => imageMessages.map((m) => buildMessageImageUrl(m.image_file_name, 'proxy')),
    [imageMessages],
  );
  const imageFullUrls = useMemo(
    () => imageMessages.map((m) => buildMessageImageUrl(m.image_file_name, null)),
    [imageMessages],
  );
  const imageModalItems = useMemo(
    () => imageMessages.map((m) => ({
      ...m,
      messageId: m.id,
      fileName: m.image_file_name,
      src: buildMessageImageUrl(m.image_file_name, 'proxy'),
      fullSrc: buildMessageImageUrl(m.image_file_name, null),
      downloadUrl: buildMessageImageUrl(m.image_file_name, null),
    })),
    [imageMessages],
  );

  /* サイドパネル用サマリー（管理者参加者 / オファー・契約） */
  const adminParticipants = personalAdminParticipants;

  const announcementSummaries = useMemo(() => ({
    offers: offerAnnouncements,
    contracts: contractAnnouncements,
  }), [offerAnnouncements, contractAnnouncements]);

  useEffect(() => {
    let cancelled = false;

    const fetchOffers = async () => {
      try {
        const data = await listArtistHoldCastings();
        const list = Array.isArray(data) ? data : (Array.isArray(data?.offers) ? data.offers : []);
        return list.map(mapArtistOfferSummaryEntry);
      } catch (err) {
        console.error('Failed to fetch offers for side panel:', err);
        toastError('オファー情報の取得に失敗しました');
        return [];
      }
    };

    const fetchContracts = async () => {
      try {
        const data = await listArtistContracts();
        const list = Array.isArray(data?.contracts) ? data.contracts : [];
        return list.map(mapArtistContractSummaryEntry);
      } catch (err) {
        console.error('Failed to fetch contracts for side panel:', err);
        toastError('本契約情報の取得に失敗しました');
        return [];
      }
    };

    (async () => {
      const [offers, contracts] = await Promise.all([fetchOffers(), fetchContracts()]);
      if (cancelled) return;
      setOfferAnnouncements(sortAndTrimSummaryEntries(offers));
      setContractAnnouncements(sortAndTrimSummaryEntries(contracts));
    })();

    return () => {
      cancelled = true;
    };
  }, [toastError]);

  const imageIndexByMessageId = useMemo(() => {
    const map = new Map();
    imageMessages.forEach((m, idx) => {
      if (m?.id != null) map.set(m.id, idx);
    });
    return map;
  }, [imageMessages]);
  const displayMessages = useMemo(
    () => buildImageGroupDisplayMessages(messages),
    [messages],
  );
  const shouldShowChatGuidance = useChatGuidanceVisibility({
    scopeKey: String(artistUser?.userId || '') ? chatTopics.modeKey : '',
    settled: Boolean(chatTopics.loadedMessageModeKey === chatTopics.modeKey && initialLoaded && !isFetching && !isInitialLoading && !loadingOlderMessages && !loadingNewerMessages),
    hasOlder: hasMore,
  });
  const handleImageClick = (imageIndex) => {
    if (imageIndex == null || imageIndex < 0 || imageIndex >= imageFullUrls.length) return;
    setCurrentImageIndex(imageIndex);
    setIsModalOpen(true);
    if (!imageModalHistoryRef.current.pushed) {
      try {
        const baseState =
          window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
        window.history.pushState({ ...baseState, chatImageModal: true }, '');
        imageModalHistoryRef.current.pushed = true;
        imageModalHistoryRef.current.closing = false;
      } catch {
        imageModalHistoryRef.current.pushed = false;
        imageModalHistoryRef.current.closing = false;
      }
    }
  };

  // ▼ 右＝最新へ、左＝過去へ（ループしない）
  const goNewer = useCallback(() => {
    setCurrentImageIndex((prev) => (prev <= 0 ? 0 : prev - 1));
  }, []);
  const goOlder = useCallback(() => {
    setCurrentImageIndex((prev) => (prev >= imageFullUrls.length - 1 ? prev : prev + 1));
  }, [imageFullUrls.length]);

  // スワイプ（左＝最新 / 右＝過去）
  const touchStartXRef = useRef(0);
  const touchStartYRef = useRef(0);
  const handleTouchStart = (e) => {
    const t = e.changedTouches[0];
    touchStartXRef.current = t.clientX;
    touchStartYRef.current = t.clientY;
  };
  const handleTouchEnd = (e) => {
    const t = e.changedTouches[0];
    const dx = t.clientX - touchStartXRef.current;
    const dy = t.clientY - touchStartYRef.current;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) {
        goNewer();
      } else {
        goOlder();
      }
    }
  };

  // 画像／ファイル ダウンロード
  const handleDownload = (type, id, originalName) => {
    const url = type === 'image'
      ? `${API_URL}/api/artist/messages/images/${id}/download`
      : `${API_URL}/api/artist/messages/files/${id}/download`;
    try {
      openExternalUrl(url);
    } catch (e) {
      console.error('Download error:', e, { type, id, originalName });
    }
  };

  const closeModal = (viaPop = false) => {
    setIsModalOpen(false);
    if (!viaPop && imageModalHistoryRef.current.pushed) {
      imageModalHistoryRef.current.closing = true;
      try {
        window.history.back();
      } catch {
        imageModalHistoryRef.current.pushed = false;
        imageModalHistoryRef.current.closing = false;
      }
      return;
    }
    imageModalHistoryRef.current.pushed = false;
    imageModalHistoryRef.current.closing = false;
  };

  const formatMessageContent = (content) => {
    if (!content) return null;
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line.split(urlPattern).map((part, index2) =>
          urlPattern.test(part) ? (
            <a key={index2} href={part} target="_blank" rel="noopener noreferrer">
              {part}
            </a>
          ) : (
            part
          )
        )}
        <br />
      </React.Fragment>
    ));
  };

  const extractFirstUrl = (content) => {
    if (!content) return '';
    const match = String(content).match(/https?:\/\/[^\s]+/);
    return match ? match[0] : '';
  };
  const getHoldDeclineLink = (message) => {
    if (!message?.hold_casting_id) return '';
    return `/artist/workspaces/casting/offers/${message.hold_casting_id}`;
  };

  // 初期表示は mount 時のみ行う
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchGenres();
    fetchInitialMessages(true, { anchorMessageId: initialQuestionTarget.personalAnchorMessageId }).finally(() => {
      lastDiffFetchRef.current = Date.now();
      setInitialLoaded(true);
    });
  }, []);

  // ▼ バナー：毎回3秒で自動消滅
  const showBanner = useCallback(() => {
    setShowNewMsgBanner(true);
    if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);
    bannerTimeoutRef.current = setTimeout(() => setShowNewMsgBanner(false), 3000);
  }, []);
  useEffect(() => {
    return () => {
      if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);
    };
  }, []);

  /*──────────────────────────────────────────────
    WebSocket
  ──────────────────────────────────────────────*/
  useEffect(() => {
    const socket = getSocket();
    if (!socket.connected) {
      try { socket.connect(); } catch (e) { console.error('[socket] connect error:', e); }
    }

    // §3.3 RECONNECT: 再接続時に開いている個別チャットを最新へ再同期(silent)。
    // handleNewMessage の stale フォールバック(fetchInitialMessagesRef 経由の強制再取得)と
    // 同じ既存経路を再利用する。個別チャットが非アクティブなら何もしない。
    const handleConnect = () => {
      if (!isPersonalTargetActiveRef.current) return;
      const fetchInitial = fetchInitialMessagesRef.current;
      if (!fetchInitial) return;
      fetchInitial(true)
        .then(() => {
          lastDiffFetchRef.current = Date.now();
        })
        .catch(() => {});
    };

    const handleNewMessage = async (data = {}) => {
      refreshPendingMentionTargets();
      const atTopBefore = isViewingLatest();
      const currentArtist = artistUserRef.current;
	      const pageVisible = isPageVisibleRef.current;
	      const canAutoReadNow = pageVisible && atTopBefore && isPersonalTargetActiveRef.current;
	      const senderArtistId =
	        data?.senderArtistId ||
	        data?.sender_artist_id ||
	        (String(data?.senderType || data?.sender_type || '').toLowerCase() === 'artist'
	          ? data?.senderId || data?.sender_id
	          : data?.artistId);
	      const isSelf =
	        isSameId(senderArtistId, currentArtist?.userId) ||
	        isSameId(data?.artistId, currentArtist?.userId);
	      const currentMessages = messagesRef.current;
	      const newest = currentMessages[0]?.created_at;
	      const realtimeMessage = buildRealtimePersonalTextMessage(data);

	      if (realtimeMessage) {
	        const [displayMessage] = mapMessagesForDisplay([realtimeMessage]);
	        if (displayMessage) {
	          setMessages((prev) => mergeMessagesByIdDesc(prev, [displayMessage]));
	          lastDiffFetchRef.current = Date.now();
	          const isAdminMessage = displayMessage.message_type === 'admin_message';
	          const isSelfArtistMessage = displayMessage.message_type === 'artist_message' && isSelf;

	          if (atTopBefore && isPersonalTargetActiveRef.current) {
	            requestAnimationFrame(() => {
	              scrollToLatest();
	            });
	          }

	          if (isAdminMessage) {
	            if (canAutoReadNow) {
	              const marked = await markMessagesAsRead();
	              if (chatTopics.canClearParentUnread()) setUnreadCount(0);
	              if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
	              if (marked) setMessages((prev) =>
	                prev.map((m) =>
	                  m.message_type === 'admin_message' ? { ...m, is_read: true } : m
	                )
	              );
	            } else {
	              setUnreadCount((prev) => prev + 1);
	              setArtistMessageCount((prev) => prev + 1);
	              if (pageVisible && isPersonalTargetActiveRef.current) {
	                showBanner();
	              }
	            }
	          } else if (isSelfArtistMessage && isPersonalTargetActiveRef.current) {
	            requestAnimationFrame(() => {
	              scrollToLatest();
	            });
	          }
	        }

	        return;
	      }

	      // A) 管理者からの新着
	      if (data.adminUserId) {
        const stale = Date.now() - lastDiffFetchRef.current > STALE_MS;
        if (!newest || stale) {
          const fetchInitial = fetchInitialMessagesRef.current;
          if (fetchInitial) {
            await fetchInitial(true);
          }
          lastDiffFetchRef.current = Date.now();
          if (pageVisible && !atTopBefore && isPersonalTargetActiveRef.current) {
            showBanner();
          }
          return;
        }

        const { messages: fetched = [] } = await listArtistNewMessages(newest);
        lastDiffFetchRef.current = Date.now();

        const existingIds = new Set(currentMessages.map((m) => m.id));
        const additions = fetched
          .filter((m) => !existingIds.has(m.id))
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
          .map((m) => ({
            ...m,
            className: getMessageClass(m),
            genreLabel:
              isHoldAnnouncementFormat(m.message_format)
                ? getGenreLabelFromCache(m.event_genre)
                : undefined,
          }));
        if (!additions.length) return;

        setMessages((prev) => mergeMessagesByIdDesc(prev, additions));

        const adminAdditionsCount = additions.filter((m) => m.message_type === 'admin_message').length;

        if (canAutoReadNow) {
          requestAnimationFrame(() => {
            scrollToLatest();
          });
          const marked = await markMessagesAsRead();
          if (chatTopics.canClearParentUnread()) setUnreadCount(0);
          if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
          if (marked) setMessages((prev) =>
            prev.map((m) =>
              m.message_type === 'admin_message' ? { ...m, is_read: true } : m
            )
          );
        } else if (adminAdditionsCount > 0) {
          setUnreadCount((prev) => prev + adminAdditionsCount);
          setArtistMessageCount((prev) => prev + adminAdditionsCount);
          if (pageVisible && isPersonalTargetActiveRef.current) {
            showBanner();
          }
        }
        return;
      }

      // B) 自分が送ったメッセージ（バナーは出さない）
      if (isSelf) {
        const stale = Date.now() - lastDiffFetchRef.current > STALE_MS;
        if (!newest || stale) {
          const fetchInitial = fetchInitialMessagesRef.current;
          if (fetchInitial) {
            await fetchInitial(true);
          }
          lastDiffFetchRef.current = Date.now();
          requestAnimationFrame(() => {
            scrollToLatest();
          });
          return;
        }

        const { messages: fetched = [] } = await listArtistNewMessages(newest);
        lastDiffFetchRef.current = Date.now();

        const existIds = new Set(currentMessages.map((m) => m.id));
        const additions = fetched
          .filter((m) => !existIds.has(m.id))
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
          .map((m) => ({ ...m, className: getMessageClass(m) }));
        if (additions.length) {
          setMessages((prev) => mergeMessagesByIdDesc(prev, additions));
        }

        if (isPersonalTargetActiveRef.current) {
          requestAnimationFrame(() => {
            scrollToLatest();
          });
        }
        return;
      }

      // C) フォールバック
      const stale = Date.now() - lastDiffFetchRef.current > STALE_MS;
      if (!newest || stale) {
        const fetchInitial = fetchInitialMessagesRef.current;
        if (fetchInitial) {
          await fetchInitial(true);
        }
        lastDiffFetchRef.current = Date.now();
        return;
      }

      const { messages: fetched = [] } = await listArtistNewMessages(newest);
      lastDiffFetchRef.current = Date.now();

      const existingIds = new Set(currentMessages.map((m) => m.id));
      const additions = fetched
        .filter((m) => !existingIds.has(m.id))
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        .map((m) => ({
          ...m,
          className: getMessageClass(m),
          genreLabel:
            isHoldAnnouncementFormat(m.message_format)
              ? getGenreLabelFromCache(m.event_genre)
              : undefined,
        }));
      if (!additions.length) return;

      setMessages((prev) => mergeMessagesByIdDesc(prev, additions));

      const hasOnlySelfMessages = additions.every((m) => m.message_type === 'artist_message');
      if (hasOnlySelfMessages) {
        requestAnimationFrame(() => {
          scrollToLatest();
        });
        return;
      }

      const adminAdditionsCount = additions.filter((m) => m.message_type === 'admin_message').length;
      if (adminAdditionsCount > 0) {
        if (canAutoReadNow) {
          requestAnimationFrame(() => {
            scrollToLatest();
          });
          const marked = await markMessagesAsRead();
          if (chatTopics.canClearParentUnread()) setUnreadCount(0);
          if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
          if (marked) setMessages((prev) =>
            prev.map((m) =>
              m.message_type === 'admin_message' ? { ...m, is_read: true } : m
            )
          );
        } else {
          setUnreadCount((prev) => prev + adminAdditionsCount);
          setArtistMessageCount((prev) => prev + adminAdditionsCount);
          if (pageVisible && isPersonalTargetActiveRef.current) {
            showBanner();
          }
        }
      }
    };

    const handleMessagesRead = ({ readMessageIds, readerType, reader_type: readerTypeSnake, readerId, reader_id: readerIdSnake } = {}) => {
      if (!isPersonalTargetActiveRef.current) return;
      if (Array.isArray(readMessageIds)) {
        setMessages((prev) => patchMessages(prev, readMessageIds, { is_read: true }));
      }
      const normalizedReaderType = String(readerType || readerTypeSnake || '').trim().toLowerCase();
      const normalizedReaderId = normalizeId(readerId || readerIdSnake);
      if (
        normalizedReaderType === 'artist' &&
        normalizedReaderId &&
        normalizedReaderId === normalizeId(artistUserRef.current?.userId)
      ) {
        if (chatTopics.canClearParentUnread()) setUnreadCount(0);
        if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
      }
    };

    const handleMessageDeleted = ({ artistId: aId, messageId, messageIds } = {}) => {
      const currentArtist = artistUserRef.current;
      if (!currentArtist || !isSameId(aId, currentArtist.artist_id)) return;
      const deletedIds = Array.isArray(messageIds) && messageIds.length
        ? messageIds.map((id) => String(id))
        : (messageId ? [String(messageId)] : []);
      if (deletedIds.length === 0) return;
      setMessages((prev) => removeMessages(prev, deletedIds));
    };

    const handleAnnouncementsUpdated = ({ artistId: aId } = {}) => {
      const currentArtist = artistUserRef.current;
      if (!currentArtist || !isSameId(aId, currentArtist.artist_id)) return;
      refreshAnnouncements({ silent: true }).catch(() => {});
    };

    const handleReactionUpdated = ({ artistId: aId, messageId } = {}) => {
      const currentArtist = artistUserRef.current;
      if (!currentArtist || !isSameId(aId, currentArtist.artist_id) || !messageId) return;
      refreshMessageReactionDetails(messageId).catch(() => {});
    };

    const handleLinkPreviewReady = makeLinkPreviewReadyHandler(setMessages);

    socket.on('connect', handleConnect);
    socket.on(SOCKET_EVENTS.NEW_MESSAGE, handleNewMessage);
    socket.on(SOCKET_EVENTS.MESSAGES_READ, handleMessagesRead);
    socket.on(SOCKET_EVENTS.MESSAGE_DELETED, handleMessageDeleted);
    socket.on(SOCKET_EVENTS.CHAT_ANNOUNCEMENTS_UPDATED, handleAnnouncementsUpdated);
    socket.on(SOCKET_EVENTS.CHAT_MESSAGE_REACTION_UPDATED, handleReactionUpdated);
    socket.on(SOCKET_EVENTS.CHAT_LINK_PREVIEW_READY, handleLinkPreviewReady);

    return () => {
      socket.off('connect', handleConnect);
      socket.off(SOCKET_EVENTS.NEW_MESSAGE, handleNewMessage);
      socket.off(SOCKET_EVENTS.MESSAGES_READ, handleMessagesRead);
      socket.off(SOCKET_EVENTS.MESSAGE_DELETED, handleMessageDeleted);
      socket.off(SOCKET_EVENTS.CHAT_ANNOUNCEMENTS_UPDATED, handleAnnouncementsUpdated);
      socket.off(SOCKET_EVENTS.CHAT_MESSAGE_REACTION_UPDATED, handleReactionUpdated);
      socket.off(SOCKET_EVENTS.CHAT_LINK_PREVIEW_READY, handleLinkPreviewReady);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [
	    getGenreLabelFromCache,
	    isViewingLatest,
	    markMessagesAsRead,
	    mapMessagesForDisplay,
	    refreshAnnouncements,
	    refreshPendingMentionTargets,
	    refreshMessageReactionDetails,

	    scrollToLatest,
	    setArtistMessageCount,
	    showBanner,
	  ]);

  /* ─────────────────────────────
     DnD（判定は共通の buildChatDropPlan。画像は最大5枚を1メッセージ、
     その他のファイルは全件を1件ずつ。混在も送り切る）
  ───────────────────────────── */
  const uploadImages = async (images) => {
    try {
      setIsUploading(true);
      const body = { images: images.slice(0, 5) };
      if (replyDraft?.messageId) body.replyToMessageId = String(replyDraft.messageId);
      await sendArtistImageMessages(body);
      // 送信完了 → 最新反映
      await fetchInitialMessages(true);
      setReplyDraft(null);
      requestAnimationFrame(() => {
        scrollToLatest();
      });
    } catch (err) {
      console.error('uploadImages error', err);
      toastError('画像の送信に失敗しました。時間をおいて再度お試しください。');
    } finally {
      setIsUploading(false);
    }
  };

  const uploadFile = async (file) => {
    try {
      setIsUploading(true);
      const body = { file };
      if (replyDraft?.messageId) body.replyToMessageId = String(replyDraft.messageId);
      await sendArtistFileMessage(body);
      await fetchInitialMessages(true);
      setReplyDraft(null);
      requestAnimationFrame(() => {
        scrollToLatest();
      });
    } catch (err) {
      console.error('uploadFile error', err);
      toastError('ファイルの送信に失敗しました。時間をおいて再度お試しください。');
    } finally {
      setIsUploading(false);
    }
  };

  const handleDropFiles = async (fileList, { rejectedCount = 0 } = {}) => {
    const plan = buildChatDropPlan(fileList, { rejectedCount });
    if (plan.notice) toastError(plan.notice);
    if (!plan.hasSendable) return;

    if (plan.images.length) await uploadImages(plan.images);
    for (const file of plan.files) {
      // eslint-disable-next-line no-await-in-loop -- 送信順を保つため直列に送る
      await uploadFile(file);
    }
  };

  // ★ 共通D&Dフック適用
  const { isDragActive, overlayRect } = useChatDragDrop({
      areaRef: chatWrapRef,
      highlightRef: chatWrapRef, // 枠線ハイライトも同じ外枠で
      enabled: !isModalOpen,
      maxBytes: 100 * 1024 * 1024,
      onInvalid: (msg) => toastError(msg || 'ドラッグ＆ドロップは現在利用できません。'),
      onDrop: (files, { rejectedCount }) => handleDropFiles(files, { rejectedCount }),
  });

  const containerMobileClass =
    isMobile
      ? resolvedMobileView === 'list'
        ? ' is-mobile is-mobile-list'
        : ' is-mobile is-mobile-chat'
      : '';

  const handleBannerClick = async () => {
    setShowNewMsgBanner(false);
    if (bannerTimeoutRef.current) clearTimeout(bannerTimeoutRef.current);
    try {
      setActiveAnchorMessageId('');
      setHasNewerMessages(false);
      await fetchInitialMessages(false, { anchorMessageId: '' });
      scrollToLatest();
      if (isPersonalTargetActiveRef.current && unreadCount > 0) {
        dbg('✅ banner click → force mark read');
        const marked = await markMessagesAsRead();
        if (chatTopics.canClearParentUnread()) setUnreadCount(0);
        if (chatTopics.canClearParentUnread()) setArtistMessageCount(0);
        if (marked) setMessages((prev) =>
          prev.map((m) => (m.message_type === 'admin_message' ? { ...m, is_read: true } : m))
        );
      }
    } catch (error) {
      console.error('[ArtistChatPage] failed to jump latest from banner:', error);
    }
  };

  useTopicModeReload(chatTopics, (anchorMessageId) => fetchInitialMessages(true, { anchorMessageId }), () => { setMessages([]); });

    return (
    <ChatTopicsProvider value={chatTopics}>
    <ArtistChatPageView
      context={{
        chatTopics, selectedGroupTopic, setSelectedGroupTopic,        ADMIN_PROFILE_IMAGE_PATH, ARTIST_TARGET_ROW_CLASSES, TACTICART_PERSONAL_CHAT_TARGET_INTRO, TACTICART_TARGET_ICON_PATH, activeAnchorMessageId, activeChatTarget, adminParticipants, announcementActionMessageId, announcementCount, announcementSummaries, announcements, applyTargetSearchModal,
        artistGroupDbg, artistGroupUnreadMap, artistPersonalMessageCount, artistUser, buildAssetUrl, buildFlyerUrl, buildGroupChatIconUrl, buildGroupThreadPreviewText, buildMessageImageUrl, canAnnouncementMessage, canCopyMessage, canReactMessage,
        canReplyMessage, canUnsendMessage, chatContainerRef, chatWrapRef, clearMessageLongPress, clearTargetSearchModal, clearToolbarSearch, closeMessageMenu, closeModal, closeProfileModal, closeReactionDetail, containerMobileClass,
        currentImageIndex, displayMessages, unreadDividerMessageId, extractFirstUrl, fetchInitialMessages, filteredGroupThreads, formatMessageContent, getAdminDisplayName, getCachedFlyerUrl, getHoldDeclineLink, goNewer, goOlder, groupThreads,
        handleBannerClick, handleCopyMessage, handleDownload, handleGroupAccessLost, handleGroupThreadsRefresh, handleImageClick, handleJumpToReplyMessage, handleMentionClick, handleMessageContextMenu, handleMessageMenuReactionSelect, handleMessageTouchStart, handleMobileBackToTargetList, handleOpenInlinePartialCopy,
        handlePersonalMentionQueryChange, handleSelectAnnouncementMessage, handleSelectReplyMessage, handleToggleAnnouncementMessage, handleTouchEnd, handleTouchStart, handleUnsendMessage, handleUploading, hasMore, imageFullUrls, imageIndexByMessageId, imageMessages,
        imageModalItems, imagePreviewUrls, inlineCopyMessageId, isAnnouncedMessage, isAnnouncementListOpen, isDragActive, isGroupTarget, isLoadingGroupThreads, isMobile, isModalOpen, isPersonalTargetActive, isReactionDetailOpen,
        isReactionPending, isReadOnly, isSidePanelOpen, isSystemFormat, isTargetSearchMode, isTargetSelectionPending, isUploading, latestAnnouncement, loadingMentionResolutionTargetKey, loadingOlderMessages, mentionResolutionModalProps, messageFilter,
        messageMenu, messageMenuRef, mobileTargetListPrefRef, normalizeId, normalizedMessageFilter, noteCount, openAdminProfile, openMentionResolution, openReactionDetail, openTargetSearchModal, overlayRect, ownArtistId,
        parseReminderContent, pendingGroupMentionTargets, pendingMentionTargets, personalMentionCandidates, personalTargetRows, pickFlyerFilename, profileTarget, quickTaskInitialMentionDraft, reactionDetailGroups, reactionDetailLoading, refreshNoteCount, refreshPendingMentionTargets, renderAdminAvatar,
        renderPartialCopyContent, replyDraft, resolveGroupMentionTarget, resolveMentionTarget, resolvePrimaryGenreObj, resolvingMentionTargetId, scrollToLatest, searchDraft, searchSummaryLabel, searchToolbarChips, selectedGroupAnchorMessageId, selectedGroupThreadId,
        setActiveChatTarget, setIsAnnouncementListOpen, setIsSidePanelOpen, setMobileView, setReplyDraft, setSearchDraft, setSelectedGroupAnchorMessageId, setSelectedGroupThreadId, setSelectedPersonalAnchorMessageId, setShowNotes, setShowSearchModal, shouldShowChatGuidance,
        showDelayedInitialLoading, showMobileTargetBackButton, showNewMsgBanner, showNotes, showPersonalTargetRow, showSearchModal, showTargetSidebar, toastError, toggleReaction, unpinAnnouncement, unreadCount, updateGroupThreadMeta,
      }}
    />
    </ChatTopicsProvider>
  );
}
